import { FormControl, FormGroup, Validators, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule, FormArray } from '@angular/forms';
import * as i0 from '@angular/core';
import { Component, Input, Inject, Pipe, Injectable, Directive, forwardRef, ElementRef, Self, Injector, Optional, HostBinding, NgModule, ViewChild, SkipSelf, ApplicationRef, InjectionToken, PLATFORM_ID, EventEmitter, Output } from '@angular/core';
import { CommonModule, isPlatformBrowser, Location } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import * as i1$2 from '@angular/common/http';
import { HttpHeaders, HttpRequest, HttpEventType, HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldControl, MatFormField, MAT_FORM_FIELD, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, Subject, BehaviorSubject, of, throwError, interval, merge } from 'rxjs';
import { map, filter, switchMap, flatMap, startWith, debounceTime, mergeMap } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import * as dayjs_ from 'dayjs';
import { ObjectId as ObjectId$1 } from '@leandredev/common_js';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/expansion';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/list';
import * as ɵngcc4 from '@angular/material/dialog';
import * as ɵngcc5 from '@angular/material/button';
import * as ɵngcc6 from '@angular/material/form-field';
import * as ɵngcc7 from '@angular/flex-layout/flex';
import * as ɵngcc8 from '@angular/material/input';
import * as ɵngcc9 from '@angular/forms';
import * as ɵngcc10 from '@angular/material/select';
import * as ɵngcc11 from '@angular/material/core';
import * as ɵngcc12 from '@angular/material/icon';
import * as ɵngcc13 from '@angular/platform-browser';
import * as ɵngcc14 from '@angular/common/http';
import * as ɵngcc15 from '@angular/cdk/a11y';
import * as ɵngcc16 from '@angular/material/progress-bar';
import * as ɵngcc17 from '@angular/router';
import * as ɵngcc18 from '@angular/service-worker';
import * as ɵngcc19 from 'angular-oauth2-oidc';
import * as ɵngcc20 from '@angular/material/snack-bar';

function BooleanListComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BooleanListComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const frmCtl_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", frmCtl_r4.value, " ");
} }
function BooleanListComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BooleanListComponent_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.formArr.controls);
} }
function BooleanListComponent_ng_template_8_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list-item");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "mat-action-list");
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵtext(4, " edit ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 4);
    ɵngcc0.ɵɵtext(6, " delete ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const frmCtl_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", frmCtl_r6.value, " ");
} }
function BooleanListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list");
    ɵngcc0.ɵɵtemplate(1, BooleanListComponent_ng_template_8_mat_list_item_1_Template, 7, 1, "mat-list-item", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.formArr.controls);
} }
function ModaleComponent_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("mat-dialog-close", opt_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(opt_r2);
} }
function ModaleComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, ModaleComponent_div_5_button_1_Template, 2, 2, "button", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data.options);
} }
function NumberListComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NumberListComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const frmCtl_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", frmCtl_r4.value, ", ");
} }
function NumberListComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NumberListComponent_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.formArr.controls);
} }
function NumberListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-list-item");
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 9);
    ɵngcc0.ɵɵlistener("click", function NumberListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template_button_click_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const frmCtl_r10 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.delete(frmCtl_r10); });
    ɵngcc0.ɵɵtext(4, " delete ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const frmCtl_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(frmCtl_r10.value);
} }
function NumberListComponent_ng_template_8_mat_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list");
    ɵngcc0.ɵɵtemplate(1, NumberListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template, 5, 1, "mat-list-item", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.formArr.controls);
} }
function NumberListComponent_ng_template_8_input_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 10);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r6.newCtrl);
} }
function NumberListComponent_ng_template_8_mat_select_5_mat_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", val_r14);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(val_r14);
} }
function NumberListComponent_ng_template_8_mat_select_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-select", 11);
    ɵngcc0.ɵɵlistener("valueChange", function NumberListComponent_ng_template_8_mat_select_5_Template_mat_select_valueChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.addNew(); });
    ɵngcc0.ɵɵtemplate(1, NumberListComponent_ng_template_8_mat_select_5_mat_option_1_Template, 2, 2, "mat-option", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r7.newCtrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.select);
} }
function NumberListComponent_ng_template_8_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function NumberListComponent_ng_template_8_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.addNew(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NumberListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NumberListComponent_ng_template_8_mat_list_0_Template, 2, 1, "mat-list", 1);
    ɵngcc0.ɵɵelementStart(1, "mat-form-field", 4);
    ɵngcc0.ɵɵelementStart(2, "mat-label");
    ɵngcc0.ɵɵtext(3, "nouveau");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NumberListComponent_ng_template_8_input_4_Template, 1, 1, "input", 5);
    ɵngcc0.ɵɵtemplate(5, NumberListComponent_ng_template_8_mat_select_5_Template, 2, 2, "mat-select", 6);
    ɵngcc0.ɵɵtemplate(6, NumberListComponent_ng_template_8_button_6_Template, 3, 0, "button", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.formArr);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.select || ctx_r2.select.length === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.select && ctx_r2.select.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.select || ctx_r2.select.length === 0);
} }
function StringListComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function StringListComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const frmCtl_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", frmCtl_r4.value, ", ");
} }
function StringListComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StringListComponent_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.formArr.controls);
} }
function StringListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-list-item");
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 9);
    ɵngcc0.ɵɵlistener("click", function StringListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template_button_click_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const frmCtl_r10 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.delete(frmCtl_r10); });
    ɵngcc0.ɵɵtext(4, " delete ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const frmCtl_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(frmCtl_r10.value);
} }
function StringListComponent_ng_template_8_mat_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-list");
    ɵngcc0.ɵɵtemplate(1, StringListComponent_ng_template_8_mat_list_0_mat_list_item_1_Template, 5, 1, "mat-list-item", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.formArr.controls);
} }
function StringListComponent_ng_template_8_input_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 10);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r6.newCtrl);
} }
function StringListComponent_ng_template_8_mat_select_5_mat_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", val_r14);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(val_r14);
} }
function StringListComponent_ng_template_8_mat_select_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-select", 11);
    ɵngcc0.ɵɵlistener("valueChange", function StringListComponent_ng_template_8_mat_select_5_Template_mat_select_valueChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.addNew(); });
    ɵngcc0.ɵɵtemplate(1, StringListComponent_ng_template_8_mat_select_5_mat_option_1_Template, 2, 2, "mat-option", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r7.newCtrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.select);
} }
function StringListComponent_ng_template_8_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function StringListComponent_ng_template_8_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.addNew(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function StringListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StringListComponent_ng_template_8_mat_list_0_Template, 2, 1, "mat-list", 1);
    ɵngcc0.ɵɵelementStart(1, "mat-form-field", 4);
    ɵngcc0.ɵɵelementStart(2, "mat-label");
    ɵngcc0.ɵɵtext(3, "nouveau");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, StringListComponent_ng_template_8_input_4_Template, 1, 1, "input", 5);
    ɵngcc0.ɵɵtemplate(5, StringListComponent_ng_template_8_mat_select_5_Template, 2, 2, "mat-select", 6);
    ɵngcc0.ɵɵtemplate(6, StringListComponent_ng_template_8_button_6_Template, 3, 0, "button", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.formArr);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.select || ctx_r2.select.length === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.select && ctx_r2.select.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.select || ctx_r2.select.length === 0);
} }
const _c0 = ["*"];
function UiUploaderComponent_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("Name: ", ctx_r0.value.originalName, "");
} }
function UiUploaderComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 17);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.value == null ? null : ctx_r1.value.url, ɵngcc0.ɵɵsanitizeUrl);
} }
function UiUploaderComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 18);
} }
function UiUploaderComponent_mat_progress_bar_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-progress-bar", 19);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("value", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r4.progress));
} }
const _c1 = ["UserInput"];
const _c2 = ["auto"];
const _c3 = ["selectorTable"];
const _c4 = ["newSelector"];
export { Base } from '@leandredev/common_js';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { __decorate } from 'tslib';
import * as i1 from '@angular/router';
import { Router, ActivatedRoute } from '@angular/router';
import * as i2 from 'angular-oauth2-oidc';
import { OAuthService, OAuthModule } from 'angular-oauth2-oidc';
export { OAuthService } from 'angular-oauth2-oidc';
import * as i1$1 from '@angular/service-worker';
import { SwUpdate } from '@angular/service-worker';
import { PageEvent } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { moveItemInArray } from '@angular/cdk/drag-drop';

class BooleanListComponent {
    constructor() { }
    ngOnInit() {
    }
}
BooleanListComponent.ɵfac = function BooleanListComponent_Factory(t) { return new (t || BooleanListComponent)(); };
BooleanListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BooleanListComponent, selectors: [["app-boolean-list"]], inputs: { label: "label", formArr: "formArr" }, decls: 9, vars: 3, consts: [[3, "opened", "closed"], [4, "ngIf"], ["matExpansionPanelContent", ""], [4, "ngFor", "ngForOf"], ["mat-list-item", ""]], template: function BooleanListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-accordion");
        ɵngcc0.ɵɵelementStart(1, "mat-expansion-panel", 0);
        ɵngcc0.ɵɵlistener("opened", function BooleanListComponent_Template_mat_expansion_panel_opened_1_listener() { return ctx.panelOpenState = true; })("closed", function BooleanListComponent_Template_mat_expansion_panel_closed_1_listener() { return ctx.panelOpenState = false; });
        ɵngcc0.ɵɵelementStart(2, "mat-expansion-panel-header");
        ɵngcc0.ɵɵelementStart(3, "mat-panel-title");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-panel-description");
        ɵngcc0.ɵɵtemplate(6, BooleanListComponent_ng_container_6_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(7, BooleanListComponent_ng_container_7_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, BooleanListComponent_ng_template_8_Template, 2, 1, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.openState);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.openState);
    } }, directives: [ɵngcc1.MatAccordion, ɵngcc1.MatExpansionPanel, ɵngcc1.MatExpansionPanelHeader, ɵngcc1.MatExpansionPanelTitle, ɵngcc1.MatExpansionPanelDescription, ɵngcc2.NgIf, ɵngcc1.MatExpansionPanelContent, ɵngcc2.NgForOf, ɵngcc3.MatList, ɵngcc3.MatListItem], styles: [""] });
BooleanListComponent.ctorParameters = () => [];
BooleanListComponent.propDecorators = {
    label: [{ type: Input }],
    formArr: [{ type: Input }]
};

class DateListComponent {
    constructor() { }
    ngOnInit() {
    }
}
DateListComponent.ɵfac = function DateListComponent_Factory(t) { return new (t || DateListComponent)(); };
DateListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateListComponent, selectors: [["app-date-list"]], decls: 2, vars: 0, template: function DateListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "date-list works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DateListComponent.ctorParameters = () => [];

class HtmlListComponent {
    constructor() { }
    ngOnInit() {
    }
}
HtmlListComponent.ɵfac = function HtmlListComponent_Factory(t) { return new (t || HtmlListComponent)(); };
HtmlListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HtmlListComponent, selectors: [["app-html-list"]], decls: 2, vars: 0, template: function HtmlListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "html-list works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
HtmlListComponent.ctorParameters = () => [];

class ModaleComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() {
    }
    onNoClick() {
        this.dialogRef.close();
    }
}
ModaleComponent.ɵfac = function ModaleComponent_Factory(t) { return new (t || ModaleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ModaleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModaleComponent, selectors: [["app-modale"]], decls: 6, vars: 3, consts: [["mat-dialog-title", ""], ["mat-dialog-content", ""], ["mat-dialog-actions", "", 4, "ngIf"], ["mat-dialog-actions", ""], ["mat-button", "", 3, "mat-dialog-close", 4, "ngFor", "ngForOf"], ["mat-button", "", 3, "mat-dialog-close"]], template: function ModaleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "p");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ModaleComponent_div_5_Template, 2, 1, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.options);
    } }, directives: [ɵngcc4.MatDialogTitle, ɵngcc4.MatDialogContent, ɵngcc2.NgIf, ɵngcc4.MatDialogActions, ɵngcc2.NgForOf, ɵngcc5.MatButton, ɵngcc4.MatDialogClose], styles: [""] });
ModaleComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];

class NumberListComponent {
    constructor() {
        this.newCtrl = new FormControl('');
    }
    ngOnInit() { }
    delete(ctrl) {
        let index;
        index = this.formArr.controls.indexOf(ctrl);
        if (index > -1) {
            this.formArr.removeAt(index);
        }
    }
    addNew() {
        this.formArr.push(this.newCtrl);
        // console.log(this.formArr) ;
        this.newCtrl = new FormControl('');
    }
}
NumberListComponent.ɵfac = function NumberListComponent_Factory(t) { return new (t || NumberListComponent)(); };
NumberListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NumberListComponent, selectors: [["app-number-list"]], inputs: { label: "label", select: "select", formArr: "formArr" }, decls: 9, vars: 3, consts: [[3, "opened", "closed"], [4, "ngIf"], ["matExpansionPanelContent", ""], [4, "ngFor", "ngForOf"], ["appearance", "fill"], ["matInput", "", "type", "number", "placeholder", "", 3, "formControl", 4, "ngIf"], ["placeholder", "Select", 3, "formControl", "valueChange", 4, "ngIf"], ["mat-button", "", "matSuffix", "", "mat-icon-button", "", "aria-label", "add", 3, "click", 4, "ngIf"], ["fxFlex", ""], ["mat-button", "", 3, "click"], ["matInput", "", "type", "number", "placeholder", "", 3, "formControl"], ["placeholder", "Select", 3, "formControl", "valueChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["mat-button", "", "matSuffix", "", "mat-icon-button", "", "aria-label", "add", 3, "click"]], template: function NumberListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-accordion");
        ɵngcc0.ɵɵelementStart(1, "mat-expansion-panel", 0);
        ɵngcc0.ɵɵlistener("opened", function NumberListComponent_Template_mat_expansion_panel_opened_1_listener() { return ctx.openState = true; })("closed", function NumberListComponent_Template_mat_expansion_panel_closed_1_listener() { return ctx.openState = false; });
        ɵngcc0.ɵɵelementStart(2, "mat-expansion-panel-header");
        ɵngcc0.ɵɵelementStart(3, "mat-panel-title");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-panel-description");
        ɵngcc0.ɵɵtemplate(6, NumberListComponent_ng_container_6_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(7, NumberListComponent_ng_container_7_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, NumberListComponent_ng_template_8_Template, 7, 4, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.openState);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.openState && ctx.formArr);
    } }, directives: [ɵngcc1.MatAccordion, ɵngcc1.MatExpansionPanel, ɵngcc1.MatExpansionPanelHeader, ɵngcc1.MatExpansionPanelTitle, ɵngcc1.MatExpansionPanelDescription, ɵngcc2.NgIf, ɵngcc1.MatExpansionPanelContent, ɵngcc2.NgForOf, ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc3.MatList, ɵngcc3.MatListItem, ɵngcc7.DefaultFlexDirective, ɵngcc5.MatButton, ɵngcc8.MatInput, ɵngcc9.NumberValueAccessor, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.FormControlDirective, ɵngcc10.MatSelect, ɵngcc11.MatOption, ɵngcc6.MatSuffix, ɵngcc12.MatIcon], styles: [""] });
NumberListComponent.ctorParameters = () => [];
NumberListComponent.propDecorators = {
    label: [{ type: Input }],
    select: [{ type: Input }],
    formArr: [{ type: Input }]
};

class ObjectListComponent {
    constructor() { }
    ngOnInit() {
    }
}
ObjectListComponent.ɵfac = function ObjectListComponent_Factory(t) { return new (t || ObjectListComponent)(); };
ObjectListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ObjectListComponent, selectors: [["app-object-list"]], decls: 2, vars: 0, template: function ObjectListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "object-list works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
ObjectListComponent.ctorParameters = () => [];

class PasswordComponent {
    constructor() { }
    ngOnInit() {
    }
}
PasswordComponent.ɵfac = function PasswordComponent_Factory(t) { return new (t || PasswordComponent)(); };
PasswordComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordComponent, selectors: [["app-password"]], decls: 2, vars: 0, template: function PasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "password works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
PasswordComponent.ctorParameters = () => [];

class PasswordListComponent {
    constructor() { }
    ngOnInit() {
    }
}
PasswordListComponent.ɵfac = function PasswordListComponent_Factory(t) { return new (t || PasswordListComponent)(); };
PasswordListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordListComponent, selectors: [["app-password-list"]], decls: 2, vars: 0, template: function PasswordListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "password-list works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
PasswordListComponent.ctorParameters = () => [];

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc13.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];

class StringListComponent {
    constructor() {
        this.newCtrl = new FormControl('');
    }
    ngOnInit() { }
    delete(ctrl) {
        let index;
        index = this.formArr.controls.indexOf(ctrl);
        if (index > -1) {
            this.formArr.removeAt(index);
        }
    }
    addNew() {
        this.formArr.push(this.newCtrl);
        // console.log(this.formArr) ;
        this.newCtrl = new FormControl('');
    }
}
StringListComponent.ɵfac = function StringListComponent_Factory(t) { return new (t || StringListComponent)(); };
StringListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StringListComponent, selectors: [["app-string-list"]], inputs: { label: "label", select: "select", formArr: "formArr" }, decls: 9, vars: 3, consts: [[3, "opened", "closed"], [4, "ngIf"], ["matExpansionPanelContent", ""], [4, "ngFor", "ngForOf"], ["appearance", "fill"], ["matInput", "", "placeholder", "", 3, "formControl", 4, "ngIf"], ["placeholder", "Select", 3, "formControl", "valueChange", 4, "ngIf"], ["mat-button", "", "matSuffix", "", "mat-icon-button", "", "aria-label", "add", 3, "click", 4, "ngIf"], ["fxFlex", ""], ["mat-button", "", 3, "click"], ["matInput", "", "placeholder", "", 3, "formControl"], ["placeholder", "Select", 3, "formControl", "valueChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["mat-button", "", "matSuffix", "", "mat-icon-button", "", "aria-label", "add", 3, "click"]], template: function StringListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-accordion");
        ɵngcc0.ɵɵelementStart(1, "mat-expansion-panel", 0);
        ɵngcc0.ɵɵlistener("opened", function StringListComponent_Template_mat_expansion_panel_opened_1_listener() { return ctx.openState = true; })("closed", function StringListComponent_Template_mat_expansion_panel_closed_1_listener() { return ctx.openState = false; });
        ɵngcc0.ɵɵelementStart(2, "mat-expansion-panel-header");
        ɵngcc0.ɵɵelementStart(3, "mat-panel-title");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-panel-description");
        ɵngcc0.ɵɵtemplate(6, StringListComponent_ng_container_6_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(7, StringListComponent_ng_container_7_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, StringListComponent_ng_template_8_Template, 7, 4, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.openState);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.openState && ctx.formArr);
    } }, directives: [ɵngcc1.MatAccordion, ɵngcc1.MatExpansionPanel, ɵngcc1.MatExpansionPanelHeader, ɵngcc1.MatExpansionPanelTitle, ɵngcc1.MatExpansionPanelDescription, ɵngcc2.NgIf, ɵngcc1.MatExpansionPanelContent, ɵngcc2.NgForOf, ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc3.MatList, ɵngcc3.MatListItem, ɵngcc7.DefaultFlexDirective, ɵngcc5.MatButton, ɵngcc8.MatInput, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.FormControlDirective, ɵngcc10.MatSelect, ɵngcc11.MatOption, ɵngcc6.MatSuffix, ɵngcc12.MatIcon], styles: [""] });
StringListComponent.ctorParameters = () => [];
StringListComponent.propDecorators = {
    label: [{ type: Input }],
    select: [{ type: Input }],
    formArr: [{ type: Input }]
};

class TexteListComponent {
    constructor() { }
    ngOnInit() {
    }
}
TexteListComponent.ɵfac = function TexteListComponent_Factory(t) { return new (t || TexteListComponent)(); };
TexteListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TexteListComponent, selectors: [["app-texte-list"]], decls: 2, vars: 0, template: function TexteListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "texte-list works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
TexteListComponent.ctorParameters = () => [];

class Adaptater {
    fsoUrlResolver() {
        throw new Error("l'adaptater doit être configuré");
        return;
    }
    tokenResolver() {
        throw new Error("l'adaptater doit être configuré");
        return;
    }
    getProxyData(colName, idRef) {
        throw new Error("l'adaptater doit être configuré");
        return;
    }
}
Adaptater.ɵfac = function Adaptater_Factory(t) { return new (t || Adaptater)(); };
Adaptater.ɵprov = i0.ɵɵdefineInjectable({ factory: function Adaptater_Factory() { return new Adaptater(); }, token: Adaptater, providedIn: "root" });

class BaseComponent {
    constructor() {
        this.subscription = new Subscription();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
BaseComponent.ɵfac = function BaseComponent_Factory(t) { return new (t || BaseComponent)(); };
BaseComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BaseComponent });

class UiRefComponent extends BaseComponent {
    constructor(adaptaterService) {
        super();
        this.adaptaterService = adaptaterService;
    }
    ngOnInit() {
        this.subscription.add(this.adaptaterService.getProxyData(this.colName, this.idRef)
            .subscribe((data) => {
            this.data = data;
        }));
    }
}
UiRefComponent.ɵfac = function UiRefComponent_Factory(t) { return new (t || UiRefComponent)(ɵngcc0.ɵɵdirectiveInject(Adaptater)); };
UiRefComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UiRefComponent, selectors: [["app-ui-ref"]], inputs: { colName: "colName", idRef: "idRef" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function UiRefComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
UiRefComponent.ctorParameters = () => [
    { type: Adaptater }
];
UiRefComponent.propDecorators = {
    colName: [{ type: Input }],
    idRef: [{ type: Input }]
};

class UiUploaderService {
    constructor(http) {
        this.http = http;
        this.progress = new Subject();
        this.message = new Subject();
        this.uploadedFileInfo = new Subject();
    }
    initFsoFileUrl(url) {
        this.fsoFileUrl = `${url}file/`;
    }
    initToken(token) {
        this.token = token;
    }
    resetValues() {
        this.progress.next(0);
        this.message.next('');
        this.uploadedFileInfo.next(undefined);
    }
    checkFileConfirmity(file, accept, limitSize = -1) {
        if (!this.ckeckAcceptFileType(file.type, accept)) {
            window.alert(`Nous n'acceptons pas ce type de fichier.`);
            return false;
        }
        if (limitSize === -1) {
            return true;
        }
        if (file.size > limitSize) {
            window.alert(`Votre Image est trop lourde (> ${limitSize})`);
            return false;
        }
        return true;
    }
    ckeckAcceptFileType(fileType, accept) {
        const acceptTypes = accept
            .split(',')
            .map((a) => a.split('.'))
            .reduce((acc, val) => acc.concat(val), [])
            .map((a) => a.split('/'))
            .reduce((acc, val) => acc.concat(val), [])
            .filter((a) => !!a)
            .filter((a) => a !== '*');
        const fileTypes = fileType.split('/');
        for (const ft of fileTypes) {
            if (acceptTypes.includes(ft)) {
                return true;
            }
        }
        return false;
    }
    uploadFile(file) {
        // console.log('[UiUploaderService] Starting Upload file');
        this.progress.next(0);
        this.message.next('Uploading file...');
        const formData = new FormData();
        formData.append('file', file);
        const customHeaders = new HttpHeaders({
            JWT: this.token,
        });
        const customOptions = {
            headers: customHeaders,
            reportProgress: true,
        };
        const req = new HttpRequest('POST', this.fsoFileUrl, formData, customOptions);
        this.http.request(req).subscribe((event) => {
            this.getEventMessage(event, file);
        }, (err) => {
            this.message.next(`Error : ${err.message}`);
        });
    }
    uploadFileFromUrl(url) {
        fetch(url)
            .then((e) => {
            return e.blob();
        })
            .then((blob) => {
            const b = blob;
            b.lastModifiedDate = new Date();
            b.name = 'Downloaded from url';
            return b;
        })
            .then((file) => {
            // console.log(file);
            this.uploadFile(file);
        });
    }
    getEventMessage(event, file) {
        switch (event.type) {
            case HttpEventType.Sent:
                // console.log('[UiUploaderService] File Sent', file.name, file.size);
                break;
            case HttpEventType.UploadProgress:
                const percentDone = Math.round((100 * event.loaded) / event.total);
                this.progress.next(percentDone);
                break;
            case HttpEventType.Response:
                const res = event.body;
                // console.log('[UiUploaderService] File uploaded', res);
                const item = res.response[0];
                this.uploadedFileInfo.next({
                    id: item.id,
                    originalname: item.originalname,
                    url: item.fileUrl,
                });
                this.message.next('');
                break;
            default:
            // console.log('[UiUploaderService] Unknown event type', event.type);
        }
    }
    getImage(imageUrl) {
        this.http
            .get(imageUrl, { responseType: 'blob' })
            .pipe(map((res) => {
            // console.log('getImage', res);
            return new Blob([res.body]);
        }))
            .subscribe((data) => {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                this.uploadedFileInfo.next({
                    id: 'local',
                    originalname: imageUrl,
                    url: reader.result,
                });
            });
            reader.readAsDataURL(data);
        });
    }
}
UiUploaderService.ɵfac = function UiUploaderService_Factory(t) { return new (t || UiUploaderService)(ɵngcc0.ɵɵinject(ɵngcc14.HttpClient)); };
UiUploaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UiUploaderService, factory: UiUploaderService.ɵfac });
UiUploaderService.ctorParameters = () => [
    { type: HttpClient }
];

class UiUploaderComponent extends BaseComponent {
    constructor(elRef, fm, uiUploaderService, injector, _formField, adaptaterService) {
        super();
        this.elRef = elRef;
        this.fm = fm;
        this.uiUploaderService = uiUploaderService;
        this.injector = injector;
        this._formField = _formField;
        this.adaptaterService = adaptaterService;
        this.accept = 'image/*';
        this.limitSize = -1;
        this.stateChanges = new Subject();
        this.id = `ui-uploader-${UiUploaderComponent.nextId++}`;
        this._required = false;
        this._disabled = false;
        this.controlType = 'ui-uploader';
        this.urlForm = new FormGroup({
            url: new FormControl(null, Validators.required),
        });
        this.urlToUpload = '';
        this._onChange = (_) => { };
        this.subscription.add(this.adaptaterService.fsoUrlResolver().subscribe((data) => {
            if (data) {
                this.fsoFileUrl = data;
            }
        }));
        this.subscription.add(this.adaptaterService.tokenResolver().subscribe((data) => {
            if (data) {
                this.uiUploaderService.initToken(data);
                this.token = data;
            }
        }));
        this.subscription.add(fm.monitor(elRef.nativeElement, true).subscribe((origin) => {
            this.focused = !!origin;
            this.stateChanges.next();
        }));
    }
    set fsoFileUrl(value) {
        this.uiUploaderService.initFsoFileUrl(value);
    }
    get myFormGroup() {
        return this._myFormGroup;
    }
    set myFormGroup(val) {
        this._myFormGroup = val;
        this.formValueChange();
        if (this.myFormGroupSubscription) {
            this.subscription.remove(this.myFormGroupSubscription);
            this.myFormGroupSubscription.unsubscribe();
        }
        this.myFormGroupSubscription = this.myFormGroup.valueChanges.subscribe((values) => {
            this.formValueChange();
        });
        this.subscription.add(this.myFormGroupSubscription);
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        this.myFormGroup.patchValue(!!val
            ? { url: val.url, originalName: val.originalName, imageId: val.imageId }
            : { url: undefined, originalName: undefined, imageId: undefined });
        this.stateChanges.next();
        this._onChange(this._value);
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(plh) {
        this._placeholder = plh;
        this.stateChanges.next();
    }
    get empty() {
        return !!!this.fileToUpload;
    }
    get shouldLabelFloat() {
        return this.focused || !this.empty;
    }
    get required() {
        return this._required;
    }
    set required(req) {
        this._required = coerceBooleanProperty(req);
        this.stateChanges.next();
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(dis) {
        this._disabled = coerceBooleanProperty(dis);
        this.stateChanges.next();
    }
    get errorState() {
        if (!this.myFormGroup) {
            return false;
        }
        const urlValidatorRequired = this.hasRequiredField(this.myFormGroup);
        return urlValidatorRequired && (!this.value || !this.value.imageId);
    }
    setDescribedByIds(ids) { }
    onContainerClick(event) { }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    //#endregion
    ngOnInit() {
        this.progress = this.uiUploaderService.progress;
        this.message = this.uiUploaderService.message;
        this.subscription.add(this.uiUploaderService.uploadedFileInfo.subscribe((fileInfo) => {
            if (fileInfo) {
                this.value = {
                    url: fileInfo.url,
                    originalName: fileInfo.originalname,
                    imageId: fileInfo.id,
                };
                this.urlToUpload = '';
            }
            else {
                this.value = undefined;
            }
        }));
    }
    onFileSelect(event) {
        if (!event.target.files.length) {
            return;
        }
        this.uiUploaderService.resetValues();
        const file = event.target.files[0];
        if (!this.uiUploaderService.checkFileConfirmity(file, this.accept, this.limitSize)) {
            return;
        }
        this.fileToUpload = file;
    }
    startUpload() {
        const file = this.fileToUpload;
        this.uiUploaderService.uploadFile(file);
    }
    onNewUrl() {
        this.urlToUpload = this.urlForm.value.url;
        this.uiUploaderService.getImage(this.urlToUpload);
    }
    startUploadUrl() {
        this.uiUploaderService.uploadFileFromUrl(this.urlToUpload);
    }
    hasRequiredField(abstractControl) {
        if (abstractControl.validator) {
            const validator = abstractControl.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
        if (abstractControl.controls) {
            for (const controlName in abstractControl.controls) {
                if (abstractControl.controls[controlName]) {
                    if (this.hasRequiredField(abstractControl.controls[controlName])) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    formValueChange() {
        this._value = this.convertFormGroupToFsoImage(this.myFormGroup);
        this.stateChanges.next();
        this._onChange(this._value);
    }
    convertFormGroupToFsoImage(formGroup) {
        if (!formGroup) {
            return undefined;
        }
        return {
            url: formGroup.get('url').value,
            imageId: formGroup.get('imageId').value,
            originalName: formGroup.get('originalName').value,
        };
    }
    ngOnDestroy() {
        this.stateChanges.complete();
        this.fm.stopMonitoring(this.elRef.nativeElement);
    }
}
UiUploaderComponent.ɵfac = function UiUploaderComponent_Factory(t) { return new (t || UiUploaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc15.FocusMonitor), ɵngcc0.ɵɵdirectiveInject(UiUploaderService, 2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(MAT_FORM_FIELD, 8), ɵngcc0.ɵɵdirectiveInject(Adaptater)); };
UiUploaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UiUploaderComponent, selectors: [["app-ui-uploader"]], hostVars: 3, hostBindings: function UiUploaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
        ɵngcc0.ɵɵclassProp("floating", ctx.shouldLabelFloat);
    } }, inputs: { accept: "accept", limitSize: "limitSize", fsoFileUrl: "fsoFileUrl", myFormGroup: "myFormGroup", value: "value", placeholder: "placeholder", required: "required", disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            UiUploaderService,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => UiUploaderComponent),
                multi: true
            },
            {
                provide: MatFormFieldControl,
                useExisting: UiUploaderComponent
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 26, vars: 11, consts: [["fxLayout", "column", "fxLayoutAlign", "start center", 1, "container"], [1, "img-res"], [4, "ngIf"], [3, "src", 4, "ngIf"], ["src", "https://cdn.blacksoft.ca/assets/blacksoft/img/empty.png", 4, "ngIf"], [1, "img-ul"], ["fxLayout", "row wrap", "fxLayoutAlign", "space-around center", "fxLayoutGap", "10px"], ["type", "button", "fxFlex", "calc(60% - 10px)", "mat-raised-button", "", 3, "click"], ["hidden", "", "type", "file", "name", "files", 3, "accept", "change"], ["fileInput", ""], ["fxFlex", "40", "mat-raised-button", "", "type", "button", 3, "disabled", "click"], [1, "or-txt"], ["fxLayout", "row wrap", "fxLayoutAlign", "space-around center", "fxLayoutGap", "10px", 3, "formGroup"], ["fxFlex", "calc(60% - 10px)"], ["matInput", "", "type", "text", "formControlName", "url", "required", "", 3, "change"], ["fxFlex", "40", "mat-raised-button", "", "type", "button", 1, "url-upload", 3, "disabled", "click"], ["mode", "determinate", 3, "value", 4, "ngIf"], [3, "src"], ["src", "https://cdn.blacksoft.ca/assets/blacksoft/img/empty.png"], ["mode", "determinate", 3, "value"]], template: function UiUploaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r5 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, UiUploaderComponent_p_2_Template, 2, 1, "p", 2);
        ɵngcc0.ɵɵtemplate(3, UiUploaderComponent_img_3_Template, 1, 1, "img", 3);
        ɵngcc0.ɵɵtemplate(4, UiUploaderComponent_img_4_Template, 1, 0, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "button", 7);
        ɵngcc0.ɵɵlistener("click", function UiUploaderComponent_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r3 = ɵngcc0.ɵɵreference(10); return _r3.click(); });
        ɵngcc0.ɵɵtext(8, " S\u00E9lectionner un fichier ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 8, 9);
        ɵngcc0.ɵɵlistener("change", function UiUploaderComponent_Template_input_change_9_listener($event) { return ctx.onFileSelect($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 10);
        ɵngcc0.ɵɵlistener("click", function UiUploaderComponent_Template_button_click_11_listener() { return ctx.startUpload(); });
        ɵngcc0.ɵɵtext(12, "T\u00E9l\u00E9charger");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "p", 11);
        ɵngcc0.ɵɵtext(14, "ou");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "form", 12);
        ɵngcc0.ɵɵelementStart(16, "mat-form-field", 13);
        ɵngcc0.ɵɵelementStart(17, "mat-label");
        ɵngcc0.ɵɵtext(18, "Coller une URL");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "input", 14);
        ɵngcc0.ɵɵlistener("change", function UiUploaderComponent_Template_input_change_19_listener() { return ctx.onNewUrl(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "button", 15);
        ɵngcc0.ɵɵlistener("click", function UiUploaderComponent_Template_button_click_20_listener() { return ctx.startUploadUrl(); });
        ɵngcc0.ɵɵtext(21, "T\u00E9l\u00E9charger");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "p");
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(25, UiUploaderComponent_mat_progress_bar_25_Template, 2, 3, "mat-progress-bar", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value == null ? null : ctx.value.originalName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.value);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("accept", ctx.accept);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !!!ctx.fileToUpload);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formGroup", ctx.urlForm);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", !ctx.urlForm.valid);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 9, ctx.message));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fileToUpload);
    } }, directives: [ɵngcc7.DefaultLayoutDirective, ɵngcc7.DefaultLayoutAlignDirective, ɵngcc2.NgIf, ɵngcc7.DefaultLayoutGapDirective, ɵngcc5.MatButton, ɵngcc7.DefaultFlexDirective, ɵngcc9.ɵNgNoValidate, ɵngcc9.NgControlStatusGroup, ɵngcc9.FormGroupDirective, ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc8.MatInput, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.FormControlName, ɵngcc9.RequiredValidator, ɵngcc16.MatProgressBar], pipes: [ɵngcc2.AsyncPipe], styles: [".container[_ngcontent-%COMP%]{width:500px}.container[_ngcontent-%COMP%]   .img-res[_ngcontent-%COMP%]{text-align:center;height:400px;margin-bottom:20px}.container[_ngcontent-%COMP%]   .img-res[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:400px;height:400px;object-fit:cover}.container[_ngcontent-%COMP%]   .img-ul[_ngcontent-%COMP%]{margin-top:20px;text-align:center;padding:10px}.container[_ngcontent-%COMP%]   .img-ul[_ngcontent-%COMP%]   .or-txt[_ngcontent-%COMP%]{margin-top:10px;font-size:larger}.container[_ngcontent-%COMP%]   .url-upload[_ngcontent-%COMP%]{margin-bottom:15px}"] });
UiUploaderComponent.nextId = 0;
UiUploaderComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: FocusMonitor },
    { type: UiUploaderService, decorators: [{ type: Self }] },
    { type: Injector },
    { type: MatFormField, decorators: [{ type: Optional }, { type: Inject, args: [MAT_FORM_FIELD,] }] },
    { type: Adaptater }
];
UiUploaderComponent.propDecorators = {
    accept: [{ type: Input }],
    limitSize: [{ type: Input }],
    fsoFileUrl: [{ type: Input }],
    myFormGroup: [{ type: Input }],
    value: [{ type: Input }],
    placeholder: [{ type: Input }],
    shouldLabelFloat: [{ type: HostBinding, args: ['class.floating',] }],
    required: [{ type: Input }],
    disabled: [{ type: Input }],
    id: [{ type: HostBinding }]
};

class SharedModule {
}
SharedModule.ɵfac = function SharedModule_Factory(t) { return new (t || SharedModule)(); };
SharedModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [UiUploaderService], imports: [[
            CommonModule,
            MatSortModule,
            MatTableModule,
            MatDialogModule,
            MatButtonModule,
            MatExpansionModule,
            MatSnackBarModule,
            MatListModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatSelectModule,
            MatProgressSpinnerModule,
            MatProgressBarModule,
            HttpClientModule,
            ReactiveFormsModule,
            FormsModule,
            FlexLayoutModule,
        ], CommonModule,
        MatSortModule,
        MatTableModule,
        MatDialogModule,
        MatButtonModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatListModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule] });

const dayjs$5 = dayjs_;
class AddPipe {
    transform(value, amount, unit) {
        if (typeof amount === 'undefined' || (typeof amount === 'number' && typeof unit === 'undefined')) {
            throw new Error('AddPipe: missing required arguments');
        }
        return dayjs$5(value).add(amount, unit);
    }
}
AddPipe.ɵfac = function AddPipe_Factory(t) { return new (t || AddPipe)(); };
AddPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amAdd", type: AddPipe, pure: true });

const dayjs$4 = dayjs_;
class DateFormatPipe {
    transform(value, ...args) {
        if (!value) {
            return '';
        }
        return dayjs$4(value).format(args[0]);
    }
}
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); };
DateFormatPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amDateFormat", type: DateFormatPipe, pure: true });

const dayjs$3 = dayjs_;
class DifferencePipe {
    transform(value, otherValue, unit, precision) {
        const date = dayjs$3(value);
        const date2 = (otherValue !== null) ? dayjs$3(otherValue) : dayjs$3();
        return date.diff(date2, unit, precision);
    }
}
DifferencePipe.ɵfac = function DifferencePipe_Factory(t) { return new (t || DifferencePipe)(); };
DifferencePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amDifference", type: DifferencePipe, pure: true });

const dayjs$2 = dayjs_;
class FromUnixPipe {
    transform(value, ...args) {
        if (typeof value === 'string') {
            value = +value;
        }
        return dayjs$2(value).unix();
    }
}
FromUnixPipe.ɵfac = function FromUnixPipe_Factory(t) { return new (t || FromUnixPipe)(); };
FromUnixPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amFromUnix", type: FromUnixPipe, pure: true });

const dayjs$1 = dayjs_;
class ParsePipe {
    transform(value, format) {
        return dayjs$1(value).format(format);
    }
}
ParsePipe.ɵfac = function ParsePipe_Factory(t) { return new (t || ParsePipe)(); };
ParsePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amParse", type: ParsePipe, pure: true });

const dayjs = dayjs_;
class SubtractPipe {
    transform(value, amount, unit) {
        if (typeof amount === 'undefined' || (typeof amount === 'number' && typeof unit === 'undefined')) {
            throw new Error('SubtractPipe: missing required arguments');
        }
        return dayjs(value).subtract(amount, unit);
    }
}
SubtractPipe.ɵfac = function SubtractPipe_Factory(t) { return new (t || SubtractPipe)(); };
SubtractPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "amSubtract", type: SubtractPipe, pure: true });

class DayjsModule {
}
DayjsModule.ɵfac = function DayjsModule_Factory(t) { return new (t || DayjsModule)(); };
DayjsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DayjsModule });
DayjsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

class FormControlBase extends FormGroup {
    constructor(controls, validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.__id = new FormControl(ObjectId.stringObjectId());
        this.addControl('_id', this.__id);
        this.__class = new FormControl();
        this.addControl('_class', this.__class);
    }
    setValueFormObj(value) {
        let newControl = new FormControlBase.classes[value._class]();
        newControl.setValue(value);
        return newControl;
    }
    patchValueFormObj(value) {
        let newControl = new FormControlBase.classes[value._class]();
        newControl.patchValue(Object.assign({}, this.value, value));
        return newControl;
    }
    setValue(value, options = {}) {
        if (this.parent &&
            value &&
            value._class &&
            (!this.controls['_class'] ||
                value._class != this.controls['_class'].value)) {
            if (this.parent instanceof FormGroup) {
                let parentCtrl = this.parent;
                var parentFieldName;
                for (let name in this.parent.controls) {
                    if (this.parent.controls[name] == this) {
                        parentFieldName = name;
                        break;
                    }
                }
                parentCtrl.setControl(parentFieldName, this.setValueFormObj(value));
            }
            else {
                let parentCtrl = this.parent;
                parentCtrl.setControl(parentCtrl.controls.indexOf(this), this.setValueFormObj(value));
            }
        }
        else {
            let obj;
            for (let name in value) {
                if (!this.contains(name)) {
                    obj = this['_' + name];
                }
            }
            super.setValue(value, options);
        }
    }
    patchValue(value, options = {}) {
        if (this.parent &&
            value &&
            value._class &&
            (!this.controls['_class'] ||
                value._class != this.controls['_class'].value)) {
            if (this.parent instanceof FormGroup) {
                let parentCtrl = this.parent;
                var parentFieldName;
                for (let name in this.parent.controls) {
                    if (this.parent.controls[name] == this) {
                        parentFieldName = name;
                        break;
                    }
                }
                parentCtrl.setControl(parentFieldName, this.patchValueFormObj(value));
            }
            else {
                let parentCtrl = this.parent;
                parentCtrl.setControl(parentCtrl.controls.indexOf(this), this.patchValueFormObj(value));
            }
        }
        else {
            let obj;
            for (let name in value) {
                if (!this.contains(name)) {
                    obj = this['_' + name];
                }
            }
            super.patchValue(value, options);
        }
    }
    disable() {
        // console.log('FormControlBase Disable');
        super.disable();
        Object.keys(this.controls).forEach((key) => {
            // console.log('FormControlBase Disable le fils', key);
            this.controls[key].disable();
        });
    }
    enable() {
        // console.log('FormControlBase Enable');
        super.enable();
        Object.keys(this.controls).forEach((key) => {
            // console.log('FormControlBase Enable le fils', key);
            this.controls[key].enable();
        });
    }
}
FormControlBase.className = '';
FormControlBase.classes = {};
class ObjectId {
    constructor() { }
    static stringObjectId() {
        var _increment = Math.floor(Math.random() * 16777216);
        var _pid = Math.floor(Math.random() * 65536);
        var _machine = Math.floor(Math.random() * 16777216);
        var _timestamp = Math.floor(new Date().valueOf() / 1000);
        if (_increment > 0xffffff) {
            _increment = 0;
        }
        var timestamp = _timestamp.toString(16);
        var machine = _machine.toString(16);
        var pid = _pid.toString(16);
        var increment = _increment.toString(16);
        return ('00000000'.substr(0, 8 - timestamp.length) +
            timestamp +
            '000000'.substr(0, 6 - machine.length) +
            machine +
            '0000'.substr(0, 4 - pid.length) +
            pid +
            '000000'.substr(0, 6 - increment.length) +
            increment);
    }
}

class FormArrayOf extends FormArray {
    constructor(C, controls = [], validatorOrOpts, asyncValidator) {
        super(controls, validatorOrOpts, asyncValidator);
        this.C = C;
        this.controls = controls;
    }
    at(index) {
        return super.at(index);
    }
    push(control) {
        super.push(control);
    }
    insert(index, control) {
        super.insert(index, control);
    }
    setControl(index, control) {
        super.setControl(index, control);
    }
    setValue(value, options = {}) {
        if (value) {
            value.forEach((newValue, index) => {
                if (this.length > index) {
                    this.at(index).setValue(newValue, {
                        onlySelf: true,
                        emitEvent: options.emitEvent,
                    });
                    if (this.disabled) {
                        this.at(index).disable();
                    }
                }
                else {
                    let newControl;
                    if (newValue && newValue._class) {
                        newControl = new FormControlBase.classes[newValue._class]();
                    }
                    else {
                        newControl = new this.C();
                    }
                    newControl.setValue(newValue);
                    if (this.disabled) {
                        newControl.disable();
                    }
                    this.push(newControl);
                }
            });
            if (value.length < this.length) {
                let nbMax = this.length;
                for (let i = value.length; i < nbMax; i++) {
                    this.removeAt(value.length);
                }
            }
        }
        else {
            let nbMax = this.length;
            for (let i = 0; i < nbMax; i++) {
                this.removeAt(0);
            }
        }
    }
    patchValue(value, options = {}) {
        if (value) {
            value.forEach((newValue, index) => {
                if (this.length > index) {
                    this.at(index).patchValue(newValue, {
                        onlySelf: true,
                        emitEvent: options.emitEvent,
                    });
                    if (this.disabled) {
                        this.at(index).disable();
                    }
                }
                else {
                    let newControl;
                    if (newValue && newValue._class) {
                        newControl = new FormControlBase.classes[newValue._class]();
                    }
                    else {
                        newControl = new this.C();
                    }
                    newControl.patchValue(newValue);
                    if (this.disabled) {
                        newControl.disable();
                    }
                    this.push(newControl);
                }
            });
            if (value.length < this.length) {
                let nbMax = this.length;
                for (let i = value.length; i < nbMax; i++) {
                    this.removeAt(value.length);
                }
            }
        }
        else {
            let nbMax = this.length;
            for (let i = 0; i < nbMax; i++) {
                this.removeAt(0);
            }
        }
    }
    disable() {
        super.disable();
        this.controls.forEach((control) => {
            control.disable();
        });
    }
    enable() {
        super.enable();
        this.controls.forEach((control) => {
            control.enable();
        });
    }
}

class FormDate extends FormControl {
    setValue(value, options = {}) {
        if (value) {
            super.setValue(dayjs_(value).toDate(), options);
        }
        else {
            super.setValue(value, options);
        }
    }
}

class HttpAbstractAggregaService {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
    }
}

class HttpServiceBase {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        this.subUrlValue = '';
        this.subTokenValue = '';
        this.subUrlCollection = new BehaviorSubject(null);
        this.subToken = new BehaviorSubject(null);
        if (useLocalToken) {
            this.subUrlCollectionFiltered = this.subToken.pipe(filter((data) => {
                return data !== '' && data !== null && data !== undefined;
            }), switchMap(() => {
                return this.subUrlCollection.pipe(filter((data) => {
                    return data !== '' && data !== null && data !== undefined;
                }));
            }), filter(() => {
                const tokenVal = this.subToken.getValue();
                return tokenVal !== '' && tokenVal !== null && tokenVal !== undefined;
            }));
        }
        else {
            this.subUrlCollectionFiltered = this.subUrlCollection.pipe(filter((data) => {
                // // console.log('subUrlCollection filter ' + data)
                return data !== '' && data !== null && data !== undefined;
            }));
        }
    }
    get urlCollection() {
        return this.subUrlCollection.getValue();
    }
    set urlCollection(value) {
        if (this.subUrlCollection.getValue() !== value) {
            this.subUrlValue = value;
            // // console.log('urlCollection ' + value)
            this.subUrlCollection.next(value);
        }
    }
    get token() {
        return this.subToken.getValue();
    }
    set token(value) {
        if (this.subToken.getValue() !== value) {
            this.subTokenValue = value;
            this.subToken.next(value);
        }
    }
    setHeader(options) {
        if (this.secure) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    // // console.log('headers instanceof HttpHeaders')
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
                else {
                    // // console.log('headers is not an instanceof HttpHeaders')
                    if (options.headers['JWT']) {
                    }
                    else {
                        if (this.subTokenValue) {
                            options.headers = new HttpHeaders(options.headers).set('JWT', this.subTokenValue);
                        }
                        else {
                            options.headers = new HttpHeaders(options.headers).set('JWT', '');
                        }
                    }
                }
            }
            else {
                // // console.log('create headers')
                if (this.subTokenValue) {
                    options.headers = new HttpHeaders().set('JWT', this.subTokenValue);
                }
                else {
                    options.headers = new HttpHeaders().set('JWT', '');
                }
                // {JWT:this.subTokenValue}
                // // console.log('headers', options.headers)
            }
        }
        if (this.cached) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
            }
            else {
                options.headers = new HttpHeaders({ cached: '' });
            }
        }
        return options;
    }
    delete(id, options = {}, query = '') {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.delete(this.subUrlValue + id + '/' + query, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.delete(urlCollection + id, options);
            }));
        }
    }
    get(query = '*', options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.get(this.subUrlValue + query, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.get(urlCollection + query, options);
            }));
        }
    }
    cleanArr(value) {
        const resArr = [];
        value.forEach((data) => {
            if (typeof data === 'function') {
            }
            if (typeof data === 'boolean') {
                resArr.push(data);
            }
            else if (typeof data === 'string' && data !== '') {
                resArr.push(data);
            }
            else if (typeof data === 'number') {
                resArr.push(data);
            }
            else if (data instanceof Date) {
                resArr.push(data);
            }
            else if (data instanceof Array) {
                let newArr;
                newArr = this.cleanArr(data);
                if (newArr.length > 0) {
                    resArr.push(newArr);
                }
            }
            else if (typeof data === 'object') {
                let newObj;
                newObj = this.cleanObj(data);
                if (Object.keys(newObj).length > 0) {
                    resArr.push(newObj);
                }
            }
        });
        return resArr;
    }
    cleanObj(value) {
        const newValue = {};
        for (const propName in value) {
            if (typeof value[propName] === 'function') {
            }
            else if (typeof value[propName] === 'boolean') {
                newValue[propName] = value[propName];
            }
            else if (typeof value[propName] === 'string' && value[propName] !== '') {
                newValue[propName] = value[propName];
            }
            else if (typeof value[propName] === 'number') {
                newValue[propName] = value[propName];
            }
            else if (value[propName] instanceof Date) {
                newValue[propName] = value[propName];
            }
            else if (value[propName] instanceof Array) {
                let newArr;
                newArr = this.cleanArr(value[propName]);
                if (newArr.length > 0) {
                    newValue[propName] = newArr;
                }
            }
            else if (typeof value[propName] === 'object') {
                let newObj;
                newObj = this.cleanObj(value[propName]);
                if (Object.keys(newObj).length > 0) {
                    newValue[propName] = newObj;
                }
            }
        }
        return newValue;
    }
    patch(body, options = {}, query = '') {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.patch(this.subUrlValue + query, body, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.patch(urlCollection + query, body, options);
            }));
        }
    }
    post(body, options = {}, query = '') {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.post(this.subUrlValue + query, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.post(urlCollection + query, this.cleanObj(body), options);
            }));
        }
    }
    put(body, options = {}, query = '') {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.put(this.subUrlValue + query, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.put(urlCollection + query, this.cleanObj(body), options);
            }));
        }
    }
}

class HttpViewServiceBase {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        this.subUrlValue = '';
        this.subTokenValue = '';
        this.subUrlCollection = new BehaviorSubject(null);
        this.subToken = new BehaviorSubject(null);
        if (useLocalToken) {
            this.subUrlCollectionFiltered = this.subToken.pipe(filter((data) => {
                return data !== '' && data !== null && data !== undefined;
            }), flatMap(() => {
                return this.subUrlCollection.pipe(filter((data) => {
                    return data !== '' && data !== null && data !== undefined;
                }));
            }), filter(() => {
                const tokenVal = this.subToken.getValue();
                return tokenVal !== '' && tokenVal !== null && tokenVal !== undefined;
            }));
        }
        else {
            this.subUrlCollectionFiltered = this.subUrlCollection.pipe(filter((data) => {
                // console.log('subUrlCollection filter ' + data);
                return data !== '' && data !== null && data !== undefined;
            }));
        }
    }
    get urlCollection() {
        return this.subUrlCollection.getValue();
    }
    set urlCollection(value) {
        if (this.subUrlCollection.getValue() !== value) {
            this.subUrlValue = value;
            // // console.log('urlCollection ' + value)
            this.subUrlCollection.next(value);
        }
    }
    get token() {
        return this.subToken.getValue();
    }
    set token(value) {
        if (this.subToken.getValue() !== value) {
            this.subTokenValue = value;
            this.subToken.next(value);
        }
    }
    setHeader(options) {
        if (this.secure) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    // console.log('headers instanceof HttpHeaders');
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
                else {
                    // console.log('headers is not an instanceof HttpHeaders');
                    if (options.headers['JWT']) {
                    }
                    else {
                        if (this.subTokenValue) {
                            options.headers = new HttpHeaders(options.headers).set('JWT', this.subTokenValue);
                        }
                        else {
                            options.headers = new HttpHeaders(options.headers).set('JWT', '');
                        }
                    }
                }
            }
            else {
                // console.log('create headers');
                if (this.subTokenValue) {
                    options.headers = new HttpHeaders().set('JWT', this.subTokenValue);
                }
                else {
                    options.headers = new HttpHeaders().set('JWT', '');
                }
                // {JWT:this.subTokenValue}
                // console.log('headers', options.headers);
            }
        }
        if (this.cached) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
            }
            else {
                options.headers = new HttpHeaders({ cached: '' });
            }
        }
        return options;
    }
    getBase(query = '*', options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this.token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.get(this.subUrlValue + query, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(flatMap((urlCollection) => {
                this.setHeader(options);
                return this.http.get(urlCollection + query, options);
            }));
        }
    }
}

class HttpAbstractService {
    constructor(http, secure = true, cached = false, useLocalToken = false) {
        this.http = http;
        this.secure = secure;
        this.cached = cached;
        this.useLocalToken = useLocalToken;
        this.subUrlValue = '';
        this.subTokenValue = '';
        this.subUrlCollection = new BehaviorSubject(null);
        this.subToken = new BehaviorSubject(null);
        if (useLocalToken) {
            this.subUrlCollectionFiltered = this.subToken.pipe(filter((data) => {
                return data !== '' && data != null && data !== undefined;
            }), switchMap(() => {
                return this.subUrlCollection.pipe(filter((data) => {
                    return data !== '' && data != null && data !== undefined;
                }));
            }), filter(() => {
                const tokenVal = this.subToken.getValue();
                return tokenVal !== '' && tokenVal != null && tokenVal !== undefined;
            }));
        }
        else {
            this.subUrlCollectionFiltered = this.subUrlCollection.pipe(filter((data) => {
                // console.log('subUrlCollection filter ' + data);
                return data !== '' && data != null && data !== undefined;
            }));
        }
    }
    get urlCollection() {
        return this.subUrlCollection.getValue();
    }
    set urlCollection(value) {
        if (this.subUrlCollection.getValue() !== value) {
            this.subUrlValue = value;
            // console.log('urlCollection ' + value);
            this.subUrlCollection.next(value);
        }
    }
    get _token() {
        return this.subToken.getValue();
    }
    set _token(value) {
        if (this.subToken.getValue() !== value) {
            this.subTokenValue = value;
            this.subToken.next(value);
        }
    }
    setHeader(options) {
        if (this.secure) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    // console.log('headers instanceof HttpHeaders');
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
                else {
                    // console.log('headers is not an instanceof HttpHeaders');
                    if (options.headers['JWT']) {
                    }
                    else {
                        if (this.subTokenValue) {
                            options.headers = new HttpHeaders(options.headers).set('JWT', this.subTokenValue);
                        }
                        else {
                            options.headers = new HttpHeaders(options.headers).set('JWT', '');
                        }
                    }
                }
            }
            else {
                // // console.log('create headers')
                if (this.subTokenValue) {
                    options.headers = new HttpHeaders().set('JWT', this.subTokenValue);
                }
                else {
                    options.headers = new HttpHeaders().set('JWT', '');
                }
                // {JWT:this.subTokenValue}
                // // console.log('headers', options.headers)
            }
        }
        if (this.cached) {
            if (options.headers) {
                if (options.headers instanceof HttpHeaders) {
                    const h = options.headers;
                    if (h.has('cached')) {
                    }
                    else {
                        options.headers = h.set('cached', '');
                    }
                }
            }
            else {
                options.headers = new HttpHeaders({ cached: '' });
            }
        }
        return options;
    }
    cleanArr(value) {
        const resArr = [];
        value.forEach((data) => {
            if (typeof data === 'function') {
            }
            if (typeof data === 'boolean') {
                resArr.push(data);
            }
            else if (typeof data === 'string' && data !== '') {
                resArr.push(data);
            }
            else if (typeof data === 'number') {
                resArr.push(data);
            }
            else if (data instanceof Date) {
                resArr.push(data);
            }
            else if (data instanceof Array) {
                let newArr;
                newArr = this.cleanArr(data);
                if (newArr.length > 0) {
                    resArr.push(newArr);
                }
            }
            else if (typeof data === 'object') {
                let newObj;
                newObj = this.cleanObj(data);
                if (Object.keys(newObj).length > 0) {
                    resArr.push(newObj);
                }
            }
        });
        return resArr;
    }
    cleanObj(value) {
        const newValue = {};
        for (const propName in value) {
            if (typeof value[propName] === 'function') {
            }
            else if (typeof value[propName] === 'boolean') {
                newValue[propName] = value[propName];
            }
            else if (typeof value[propName] === 'string' && value[propName] !== '') {
                newValue[propName] = value[propName];
            }
            else if (typeof value[propName] === 'number') {
                newValue[propName] = value[propName];
            }
            else if (value[propName] instanceof Date) {
                newValue[propName] = value[propName];
            }
            else if (value[propName] instanceof Array) {
                let newArr;
                newArr = this.cleanArr(value[propName]);
                if (newArr.length > 0) {
                    newValue[propName] = newArr;
                }
            }
            else if (typeof value[propName] === 'object') {
                let newObj;
                newObj = this.cleanObj(value[propName]);
                if (Object.keys(newObj).length > 0) {
                    newValue[propName] = newObj;
                }
            }
        }
        return newValue;
    }
    basePatch(url = '', body, options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.patch(this.subUrlValue + url, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.patch(urlCollection + url, this.cleanObj(body), options);
            }));
        }
    }
    basePost(url = '', body, options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.post(this.subUrlValue + url, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.post(urlCollection + url, this.cleanObj(body), options);
            }));
        }
    }
    basePut(url = '', body, options = {}) {
        return this._put(url, body, options);
    }
    baseDelete(url = '', options = {}) {
        return this._delete(url, options);
    }
    baseGet(query = '*', options = {}) {
        return this._get(query, options);
    }
    // whithout IHttpResult
    _patch(url = '', body, options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.patch(this.subUrlValue + url, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.patch(urlCollection + url, this.cleanObj(body), options);
            }));
        }
    }
    _post(url = '', body, options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.post(this.subUrlValue + url, this.cleanObj(body), options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.post(urlCollection + url, this.cleanObj(body), options);
            }));
        }
    }
    _put(url = '', body, options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.put(this.subUrlValue + url, body, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.put(urlCollection + url, body, options);
            }));
        }
    }
    _delete(url = '', options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.delete(this.subUrlValue + url, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.delete(urlCollection + url, options);
            }));
        }
    }
    _get(query = '*', options = {}) {
        if (this.subUrlValue &&
            ((this.useLocalToken && this._token) || !this.useLocalToken)) {
            this.setHeader(options);
            return this.http.get(this.subUrlValue + query, options);
        }
        else {
            return this.subUrlCollectionFiltered.pipe(switchMap((urlCollection) => {
                this.setHeader(options);
                return this.http.get(urlCollection + query, options);
            }));
        }
    }
}

class AutoCompleteComponent extends BaseComponent {
    constructor() {
        super();
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.tempDate = new Date();
        this.populatedValue = [];
        this.filteredData = [];
        this._formCtrl = new FormControl();
    }
    get formArr() {
        return this.pFormAr;
    }
    set formArr(value) {
        if (value !== this.pFormAr) {
            if (this.pFormArSub) {
                this.pFormArSub.unsubscribe();
                this.pFormArSub = null;
            }
            this.pFormAr = value;
            if (this.pFormAr) {
                this.pFormArSub = this.pFormAr.valueChanges
                    .pipe(startWith(this.pFormAr.value), debounceTime(200), switchMap((ids) => {
                    if (ids && ids.length > 0) {
                        let newIds;
                        newIds = ids.filter((id) => {
                            return (this.populatedValue.find((elt) => elt._id === id) == null);
                        });
                        const currentPopulatedValue = this.populatedValue.slice();
                        if (newIds && newIds.length > 0) {
                            return this.httpServiceBase
                                .get('_id/' + newIds.join('/') + '/' + newIds.length + '/[/')
                                .pipe(map((dataRes) => {
                                if (dataRes.code === 200) {
                                    const all = currentPopulatedValue.concat(dataRes.response);
                                    this.populatedValue = ids.map((id) => {
                                        let res = all.find((elt) => {
                                            return elt._id === id;
                                        });
                                        if (res) {
                                            return res;
                                        }
                                        else {
                                            res = { _id: id, name: 'error' };
                                            return res;
                                        }
                                    });
                                }
                                else {
                                    // console.log("err: " + dataRes.message);
                                    this.populatedValue = ids.map((id) => {
                                        let res = this.populatedValue.find((elt) => {
                                            return elt._id === id;
                                        });
                                        if (res) {
                                            return res;
                                        }
                                        else {
                                            res = { _id: id, name: 'error' };
                                            return res;
                                        }
                                    });
                                }
                            }));
                        }
                        else {
                            return of(null);
                        }
                    }
                    else {
                        this.populatedValue = [];
                        return of(null);
                    }
                }))
                    .subscribe();
            }
        }
    }
    get formCtrl() {
        return this.pFormControl;
    }
    set formCtrl(value) {
        if (value !== this.pFormControl) {
            if (this.pFormControlSub) {
                this.pFormControlSub.unsubscribe();
                this.pFormControlSub = null;
            }
            this.pFormControl = value;
            if (this.pFormControl) {
                this.pFormControlSub = this.pFormControl.valueChanges
                    .pipe(startWith(this.pFormControl.value), debounceTime(200), switchMap((id) => {
                    if (id) {
                        if (this.populatedValue.find((elt) => elt._id === id)) {
                            return of(null);
                        }
                        else {
                            return this.httpServiceBase.get(id).pipe(map((dataRes) => {
                                if (dataRes.code === 200) {
                                    if (dataRes.response.length === 0) {
                                        this.populatedValue = [
                                            { _id: id, name: 'error' },
                                        ];
                                    }
                                    else {
                                        this.populatedValue = [dataRes.response[0]];
                                    }
                                }
                                else {
                                    this.populatedValue = [
                                        { _id: id, name: 'error' + dataRes.message },
                                    ];
                                    // console.log("err " + dataRes.message);
                                }
                            }));
                        }
                    }
                    else {
                        this.populatedValue = [];
                        return of(null);
                    }
                }))
                    .subscribe();
            }
        }
    }
    ngOnInit() { }
    displayFn(selected) {
        if (selected) {
            if (selected['name']) {
                return selected['name'];
            }
            else {
                return selected._id;
            }
        }
    }
    add(event) {
        // const input = event.input;
        // const value = event.value;
        // // console.log("add", event);
        // // Add our fruit
        // // Reset the input value
        // this.formCtrl.setValue(null);
    }
    remove(obj) {
        if (this.formCtrl) {
            this.formCtrl.patchValue(null);
            this.populatedValue = [];
        }
        if (this.formArr) {
            const arr = this.formArr.value;
            // console.log('remove', arr);
            if (arr) {
                const index = arr.findIndex((item) => item.toString() === obj._id.toString());
                // console.log('remove index', index);
                if (index !== -1) {
                    this.formArr.removeAt(index);
                    this.populatedValue.splice(index, 1);
                }
            }
        }
    }
    selected(event) {
        if (this.formCtrl) {
            this.formCtrl.patchValue(event.option.value._id);
            this.populatedValue = [event.option.value];
        }
        if (this.formArr) {
            const arr = this.formArr.value;
            if (arr) {
                if (arr.indexOf(event.option.value._id) === -1) {
                    arr.push(event.option.value._id);
                    this.formArr.patchValue(arr);
                    this.populatedValue.push(Object.assign({}, event.option.value));
                }
            }
        }
        this.userInput.nativeElement.value = '';
        this._formCtrl.setValue(null);
    }
    ngOnDestroy() {
        if (this.pformCtrlSub) {
            this.pformCtrlSub.unsubscribe();
            this.pformCtrlSub = null;
        }
        if (this.pFormArSub) {
            this.pFormArSub.unsubscribe();
            this.pFormArSub = null;
        }
        if (this.pFormControlSub) {
            this.pFormControlSub.unsubscribe();
            this.pFormControlSub = null;
        }
    }
}
AutoCompleteComponent.ɵfac = function AutoCompleteComponent_Factory(t) { return new (t || AutoCompleteComponent)(); };
AutoCompleteComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AutoCompleteComponent, viewQuery: function AutoCompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.matAutocomplete = _t.first);
    } }, inputs: { filteredData: "filteredData", formArr: "formArr", formCtrl: "formCtrl", placeholder: "placeholder", isLoading: "isLoading" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
AutoCompleteComponent.ctorParameters = () => [];
AutoCompleteComponent.propDecorators = {
    placeholder: [{ type: Input }],
    formArr: [{ type: Input }],
    formCtrl: [{ type: Input }],
    filteredData: [{ type: Input }],
    isLoading: [{ type: Input }],
    userInput: [{ type: ViewChild, args: ['UserInput', { static: true },] }],
    matAutocomplete: [{ type: ViewChild, args: ['auto', { static: true },] }]
};

class State {
    constructor() {
        this.data = {};
        this.exchange = new Exchange();
        this.isNew = true;
    }
}
class Exchange {
    constructor() {
        this.data = {};
    }
}
class StatesService {
    constructor(router) {
        this.router = router;
        // console.log("StatesService");
        this.states = [];
        this._currentState = new BehaviorSubject(null);
        this.currentState = this._currentState.asObservable();
    }
    get hasBack() {
        return this.states.length > 1;
    }
    navigateBack() {
        if (this.states.length > 1) {
            this.router.navigateByUrl(this.states[this.states.length - 2].url);
        }
    }
    navigateFromRoot(url) {
        if (url && this.router.url !== url) {
            this.states = [];
            this.router.navigateByUrl(url);
        }
    }
    navigateTo(url, command, data) {
        const st = this.__currentState;
        if (!data) {
            data = {};
        }
        st.exchange.command = command;
        st.exchange.data = data;
        this.router.navigateByUrl(url);
    }
    navigate(commands, extras, command, data) {
        const st = this.__currentState;
        if (!data) {
            data = {};
        }
        st.exchange.command = command;
        st.exchange.data = data;
        this.router.navigate(commands, extras);
    }
    navigatePop(commands, extras, command, data) {
        this.states.pop();
        this.router.navigate(commands, extras);
    }
    getCurrentState(id, url, defaultState = null) {
        if (!id) {
            return this.__currentState;
        }
        if (!url) {
            url = id;
        }
        // console.log("getCurrentState " + id);
        let currentState = this.getState(id);
        if (currentState) {
            if (currentState.index < this.states.length) {
                this.states.splice(currentState.index + 1, this.states.length - currentState.index);
            }
        }
        else {
            currentState = new State();
            currentState.id = id;
            currentState.name = id;
            currentState.url = url;
            if (defaultState) {
                currentState.rootUIState = defaultState;
            }
            if (this.states.length === 0) {
                currentState.prevExchange = new Exchange();
            }
            else {
                currentState.prevExchange =
                    this.states[this.states.length - 1].exchange;
            }
            this.states.push(currentState);
        }
        this.__currentState = currentState;
        this._currentState.next(this.__currentState);
        return currentState;
    }
    getState(id) {
        return this.states.find((value, index, obj) => {
            value.index = index.valueOf();
            return value.id === id;
        });
    }
}
StatesService.ɵfac = function StatesService_Factory(t) { return new (t || StatesService)(ɵngcc0.ɵɵinject(ɵngcc17.Router)); };
StatesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StatesService_Factory() { return new StatesService(i0.ɵɵinject(i1.Router)); }, token: StatesService, providedIn: "root" });
StatesService.ctorParameters = () => [
    { type: Router }
];
class RouteComponentState {
    constructor(statesService, router) {
        this.statesService = statesService;
        this.router = router;
    }
    resolve(route, state) {
        // console.log("state.url " + state.url);
        if (route.data && route.data.state) {
            return this.statesService.getCurrentState(state.url, state.url, route.data.state);
        }
        else {
            return this.statesService.getCurrentState(state.url);
        }
    }
}
RouteComponentState.ɵfac = function RouteComponentState_Factory(t) { return new (t || RouteComponentState)(ɵngcc0.ɵɵinject(StatesService), ɵngcc0.ɵɵinject(ɵngcc17.Router)); };
RouteComponentState.ɵprov = i0.ɵɵdefineInjectable({ factory: function RouteComponentState_Factory() { return new RouteComponentState(i0.ɵɵinject(StatesService), i0.ɵɵinject(i1.Router)); }, token: RouteComponentState, providedIn: "root" });
RouteComponentState.ctorParameters = () => [
    { type: StatesService },
    { type: Router }
];
class UIComponentState {
    constructor(parent) {
        this.parent = parent;
        this.data = { state: {}, child: {} };
        this._child = {};
        // console.log("UIComponentState", parent);
    }
    get state() {
        if (!this.data.state) {
            this.data.state = {};
        }
        return this.data.state;
    }
    get root() {
        if (this.parent) {
            return this.parent.root;
        }
        else {
            return null;
        }
    }
    get child() {
        if (!this._child) {
            this._child = {};
        }
        return this._child;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        if (this._id !== value) {
            this._id = value;
            if (this.parent.data.child[this._id]) {
                this.updateStateTree(this.parent.data.child[this._id]);
            }
            if (this.parent) {
                this.parent.data.child[this._id] = this.data;
                this.parent.child[this._id] = this;
            }
        }
    }
    updateStateTree(dataObj) {
        if (dataObj.state) {
            Object.assign(dataObj.state, this.data.state);
            Object.assign(this.data.state, dataObj.state);
        }
        this.data.state = dataObj.state;
        for (const iterator in dataObj.child) {
            if (this.child[iterator]) {
                this.child[iterator].updateStateTree(dataObj.child[iterator]);
            }
            else {
                this.data.child[iterator] = dataObj.child[iterator];
            }
        }
    }
    unmount() {
        if (this.parent && this.id && this.parent.child[this.id]) {
            delete this.parent.child[this.id];
        }
        this.parent = null;
        this.data = { state: {}, child: {} };
    }
    addToState(state) {
        if (state) {
            if (state.rootUIState) {
                this.updateStateTree(state.rootUIState);
            }
            state.rootUIState = this.data;
        }
        else {
            throw new Error('state is undefined');
        }
    }
}
UIComponentState.ɵfac = function UIComponentState_Factory(t) { return new (t || UIComponentState)(ɵngcc0.ɵɵinject(UIComponentState, 12)); };
UIComponentState.ɵprov = i0.ɵɵdefineInjectable({ factory: function UIComponentState_Factory() { return new UIComponentState(i0.ɵɵinject(UIComponentState, 12)); }, token: UIComponentState, providedIn: "root" });
UIComponentState.ctorParameters = () => [
    { type: UIComponentState, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

class ApiHelper {
    static resultToObjWEmptyError(message) {
        return (ObsDataResult) => {
            return ObsDataResult.pipe(mergeMap((dataResult) => {
                if (dataResult.code === 200) {
                    if (dataResult.response && dataResult.response.length > 0) {
                        return of(dataResult.response[0]);
                    }
                    else {
                        return throwError(`${message} : empty response`);
                    }
                }
                else {
                    return throwError(`${message} : ${dataResult.message}`);
                }
            }));
        };
    }
    static resultToObj(message) {
        return (ObsDataResult) => {
            return ObsDataResult.pipe(mergeMap((dataResult) => {
                if (dataResult && dataResult.code === 200) {
                    if (dataResult.response && dataResult.response.length > 0) {
                        return of(dataResult.response[0]);
                    }
                    else {
                        return of(null);
                    }
                }
                else {
                    return throwError(`${message} : ${dataResult ? dataResult.message : 'empty http data result'}`);
                }
            }));
        };
    }
    static capitalize(str) {
        return str.toUpperCase().charAt(0) + str.slice(1);
    }
    static resultToArr(message) {
        return (ObsDataResult) => {
            return ObsDataResult.pipe(mergeMap((dataResult) => {
                if (dataResult && dataResult.code === 200) {
                    if (dataResult.response && dataResult.response.length > 0) {
                        return of(dataResult.response);
                    }
                    else {
                        return of([]);
                    }
                }
                else {
                    return throwError(`${message} : ${dataResult ? dataResult.message : 'empty http data result'}`);
                }
            }));
        };
    }
    static resultToArrWEmptyError(message) {
        return (ObsDataResult) => {
            return ObsDataResult.pipe(mergeMap((dataResult) => {
                if (dataResult.code === 200) {
                    if (dataResult.response && dataResult.response.length > 0) {
                        return of(dataResult.response);
                    }
                    else {
                        return throwError(`${message} : empty response`);
                    }
                }
                else {
                    return throwError(`${message} : ${dataResult.message}`);
                }
            }));
        };
    }
}

class RunTimeDataService {
    constructor() {
        this.data = {};
        this.dataObservable = {};
    }
    getStore(name) {
        if (!this.data.hasOwnProperty(name)) {
            this.data[name] = null;
        }
        return this.data[name];
    }
    getObservableStore(name) {
        if (!this.dataObservable.hasOwnProperty(name)) {
            this.dataObservable[name] = new BehaviorSubject(this.getStore(name));
        }
        return this.dataObservable[name].asObservable();
    }
    refreshStore(name) {
        if (!this.dataObservable.hasOwnProperty(name)) {
            this.dataObservable[name] = new BehaviorSubject(this.getStore(name));
        }
        this.dataObservable[name].next(this.data[name]);
    }
    updateStore(name, value) {
        if (!this.dataObservable.hasOwnProperty(name)) {
            this.dataObservable[name] = new BehaviorSubject(this.getStore(name));
        }
        this.data[name] = value;
        this.refreshStore(name);
    }
    patchStore(name, value) {
        if (!this.dataObservable.hasOwnProperty(name)) {
            this.dataObservable[name] = new BehaviorSubject(this.getStore(name));
        }
        if (this.data[name]) {
            Object.assign(this.data[name], value);
        }
        else {
            this.data[name] = Object.assign({}, value);
        }
        this.refreshStore(name);
    }
}
RunTimeDataService.ɵfac = function RunTimeDataService_Factory(t) { return new (t || RunTimeDataService)(); };
RunTimeDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RunTimeDataService_Factory() { return new RunTimeDataService(); }, token: RunTimeDataService, providedIn: "root" });
RunTimeDataService.ctorParameters = () => [];

class AuthInterceptor {
    constructor(runTimeDataService) {
        this.runTimeDataService = runTimeDataService;
        this.subToken = new BehaviorSubject(this.token);
        this.runTimeDataService.getObservableStore('token').subscribe((data) => {
            if (data) {
                this.token = data.token;
                this.userId = data.userId;
                this.sessionId = data.sessionId;
                this.subToken.next(data.token);
            }
            else {
                this.token = null;
                this.userId = null;
                this.sessionId = null;
                this.subToken.next(null);
            }
        });
    }
    intercept(req, next) {
        if (req.headers.has('JWT')) {
            if (this.token !== '' &&
                this.token !== null &&
                this.token !== undefined) {
                // // console.log('add token')
                return next.handle(req.clone({ headers: req.headers.set('JWT', this.token) }));
            }
            else {
                return this.subToken
                    .pipe(filter((token) => {
                    return token !== '' && token !== null && token !== undefined;
                }))
                    .pipe(mergeMap((currentToken) => {
                    // // console.log('add token')
                    return next.handle(req.clone({ headers: req.headers.set('JWT', currentToken) }));
                }));
            }
        }
        else {
            // // console.log('no token')
            return next.handle(req);
        }
    }
}
AuthInterceptor.ɵfac = function AuthInterceptor_Factory(t) { return new (t || AuthInterceptor)(ɵngcc0.ɵɵinject(RunTimeDataService)); };
AuthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthInterceptor, factory: AuthInterceptor.ɵfac });
AuthInterceptor.ctorParameters = () => [
    { type: RunTimeDataService }
];

class CheckForUpdateService {
    constructor(appRef, updates) {
        this.updates = updates;
    }
    test() {
        // console.log('CheckForUpdateService');
        interval(60 * 60 * 1000).subscribe(() => {
            // console.log('update !!!');
            this.updates.checkForUpdate();
        });
    }
}
CheckForUpdateService.ɵfac = function CheckForUpdateService_Factory(t) { return new (t || CheckForUpdateService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc18.SwUpdate)); };
CheckForUpdateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CheckForUpdateService_Factory() { return new CheckForUpdateService(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i1$1.SwUpdate)); }, token: CheckForUpdateService, providedIn: "root" });
CheckForUpdateService.ctorParameters = () => [
    { type: ApplicationRef },
    { type: SwUpdate }
];

const Environment = new InjectionToken('Environment');

// a tester ... pour supprimer les lib de validation trop lourde
// la validation du jwt n aps d interet dans l app
class JwksValidationHandler {
    validateSignature(validationParams) {
        return Promise.resolve(true);
    }
    validateAtHash(validationParams) {
        return Promise.resolve(true);
    }
}
class ConfService {
    constructor(http, 
    // protected mdSnackBar: MatSnackBar,
    oauthService, router, activRoute, runTimeDataService, environment, platformId) {
        this.http = http;
        this.oauthService = oauthService;
        this.router = router;
        this.activRoute = activRoute;
        this.runTimeDataService = runTimeDataService;
        this.environment = environment;
        this.currentUser = null;
        this.notDeconnected = true;
        this.windowPerso = window;
        this.initCon = new BehaviorSubject(false);
        // console.log("ConfService constructor");
        if (this.windowPerso.daesignConfig) {
            Object.assign(environment, this.windowPerso.daesignConfig);
        }
        if (window) {
            this.originalUrl = this.windowPerso.originalUrl;
            if (this.originalUrl) {
                if (this.originalUrl.search &&
                    this.originalUrl.search.charAt(0) === "?") {
                    this.originalUrl.search = this.originalUrl.search.substring(1);
                    this.originalUrl.searchArr = this.originalUrl.search.split("&");
                    this.originalUrl.searchObj = {};
                    this.originalUrl.searchArr.forEach((element) => {
                        const keyVal = element.split("=");
                        if (keyVal.length === 2) {
                            this.originalUrl.searchObj[decodeURIComponent(keyVal[0])] =
                                decodeURIComponent(keyVal[1]);
                        }
                    });
                }
            }
        }
        this.runTimeDataService.patchStore("environment", environment);
        this.runTimeDataService.patchStore("publicConf", environment.data);
        // console.log("publicConf", environment.data);
        if (isPlatformBrowser(platformId)) {
            // URL of the SPA to redirect the user to after login
            // this.oauthService.redirectUri = document.getElementById('mybase').href;
            // The SPA's id. The SPA is registerd with this id at the auth-server
            this.oauthService.clientId = environment.ssoclientId;
            this.oauthService.issuer = environment.ssoIssuer;
            // set the scope for the permissions the client should request
            // The first three are defined by OIDC. The 4th is a usecase-specific one
            this.oauthService.scope = environment.scope;
            // set to true, to receive also an id_token via OpenId Connect (OIDC) in addition to the
            // OAuth2-based access_token
            this.oauthService.oidc = true; // ID_Token
            // Use setStorage to use sessionStorage or another implementation of the TS-type Storage
            // instead of localStorage
            this.oauthService.setStorage(localStorage);
            const authConfig = {
                // Url of the Identity Provider
                issuer: environment.ssoIssuer,
                // URL of the SPA to redirect the user to after login
                redirectUri: document.getElementById("mybase")["href"],
                // postLogoutRedirectUri: document.getElementById('mybase').href + 'deconnected',
                // The SPA's id. The SPA is registerd with this id at the auth-server
                clientId: environment.ssoclientId,
                // set the scope for the permissions the client should request
                // The first three are defined by OIDC. The 4th is a usecase-specific one
                scope: environment.scope,
                postLogoutRedirectUri: `${document.getElementById("mybase")["href"]}deconnected`,
            };
            // Discovery Document of your AuthServer as defined by OIDC
            const url = environment.ssoUrl;
            this.configurationUrl = environment.configurationUrl;
            this.sessionId = Math.random();
            // Load Discovery Document and then try to login the user
            this.oauthService.configure(authConfig);
            this.oauthService.tokenValidationHandler = new JwksValidationHandler();
            this.connected = false;
            this.oauthService.loadDiscoveryDocumentAndTryLogin().then((data) => {
                if (this.oauthService.hasValidIdToken()) {
                    this.connected = true;
                    this.claim = this.oauthService.getIdentityClaims();
                    const oriUrl = localStorage.getItem("originalUrl");
                    localStorage.removeItem("originalUrl");
                    if (oriUrl) {
                        window.location.href = oriUrl;
                    }
                    this.loadConf(this.configurationUrl, this.oauthService.getIdToken());
                }
                else {
                    if (localStorage.getItem(environment.application_instance + "idToken") &&
                        new Number(localStorage.getItem(environment.application_instance + "idTokenExp")).valueOf() -
                            Date.now() >
                            10) {
                        this.connect(localStorage.getItem(environment.application_instance + "idToken"));
                        this.connected = true;
                    }
                    else {
                        this.connected = false;
                    }
                    this.initCon.next(true);
                    // this.connected = false ;
                }
            });
        }
    }
    get endClientId() {
        return this.environment.end_client;
    }
    get application_instanceId() {
        return this.environment.application_instance;
    }
    connect(idtoken = "") {
        if (idtoken) {
            if (!this.connected) {
                this.idToken = idtoken;
                this.claim = JSON.parse(atob(idtoken.split(".")[1]));
                localStorage.setItem(this.environment.application_instance + "idToken", idtoken);
                localStorage.setItem(this.environment.application_instance + "idTokenExp", Date.now() + this.claim.exp);
                return this.loadConf(this.configurationUrl, this.idToken);
            }
        }
        else {
            if (!this.connected) {
                if (this.originalUrl &&
                    this.originalUrl.searchObj &&
                    this.originalUrl.searchObj.login_hint) {
                    this.oauthService.initImplicitFlow("", this.originalUrl.searchObj.login_hint);
                }
                else {
                    localStorage.setItem("originalUrl", window.location.href);
                    this.oauthService.initImplicitFlow();
                }
            }
        }
    }
    loadConf(url, idToken) {
        const options = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                idtoken: idToken,
            },
        };
        const res = this.http
            .get(url +
            this.environment.end_client +
            "/" +
            this.environment.application_instance, options)
            .pipe(map((data) => {
            const conf = data;
            console.info("%c Configuration load end ", "background:#f9f9f9;color:#FFFFFF;font-size:14px");
            if (conf && conf.code === 200 && conf.response && conf.response[0]) {
                this.notDeconnected = false;
                this.token = conf.response[0].token;
                this.connected = true;
                this.runTimeDataService.patchStore("token", {
                    token: this.token,
                    sessonId: this.sessionId,
                    userId: this.claim.sub,
                });
                this.runTimeDataService.patchStore("ConfService", conf.response[0]);
                if (conf.response[0].token_exp) {
                    const tokenDuration = (conf.response[0].token_exp - 30) * 1000 - Date.now();
                    if (tokenDuration > 0) {
                        window.setTimeout(() => {
                            this.refreshToken();
                        }, tokenDuration);
                    }
                    else {
                        this.refreshToken();
                    }
                }
                this.initCon.next(true);
                return of(conf.response[0]);
            }
            else {
                this.runTimeDataService.patchStore("token", null);
                this.runTimeDataService.patchStore("ConfService", null);
                this.notDeconnected = true;
                this.connected = false;
                this.router.navigateByUrl("/unautorize");
                return of();
            }
        }));
        res.subscribe((data) => { }, (err) => {
            // this.configurationBehaviorSubject.next(null) ;
            this.runTimeDataService.updateStore("token", null);
            this.runTimeDataService.updateStore("ConfService", null);
            // console.log("unautorize");
            this.router.navigateByUrl("/unautorize");
            return of();
            // if (window.location.href !== document.getElementById('mybase').href + 'unautorize') {
            //   window.location.href = document.getElementById('mybase').href + 'unautorize';
            // }
        });
        return res;
        // }
    }
    refreshToken() {
        if (this.notDeconnected) {
            return;
        }
        const headers = new HttpHeaders()
            .set("Accept", "application/json")
            .set("Content-Type", "application/json")
            .set("JWT", this.token);
        const options = { headers };
        this.http
            .get(this.environment.configurationUrl + "refreshToken", options)
            .subscribe((data) => {
            const conf = data;
            // .json() ;
            if (conf && conf.code === 200 && conf.response && conf.response[0]) {
                // console.log("data Conf", conf.response[0]);
                // this.configurationBehaviorSubject.next(conf.response[0]);
                this.token = conf.response[0].token;
                this.runTimeDataService.patchStore("token", {
                    token: this.token,
                    sessonId: this.sessionId,
                    userId: this.claim.sub,
                });
                const tokenDuration = (conf.response[0].token_exp - 30) * 1000 - Date.now();
                if (tokenDuration > 0) {
                    window.setTimeout(() => {
                        this.refreshToken();
                    }, tokenDuration);
                }
                else {
                    this.refreshToken();
                }
            }
            else {
                if (!this.oauthService.tryLogin({})) {
                    this.oauthService.initImplicitFlow();
                }
                else {
                    this.claim = this.oauthService.getIdentityClaims();
                    this.loadConf(this.environment.configurationUrl, this.oauthService.getIdToken());
                }
            }
        }, (err) => {
            if (!this.oauthService.tryLogin({})) {
                this.oauthService.initImplicitFlow();
            }
            else {
                this.claim = this.oauthService.getIdentityClaims();
                this.loadConf(this.environment.configurationUrl, this.oauthService.getIdToken());
            }
        });
    }
    // public errorSnackBar(obj: ErrorMessage): void {
    //   this.openSnackBar('Erreur: ' + obj.message);
    // }
    // public openSnackBar(message: string, action: string = 'X') {
    //   this.mdSnackBar.open(message, action, { duration: 2000 });
    // }
    internalLogout(redirectUrl = "/deconnected") {
        localStorage.setItem(this.environment.application_instance + "idToken", null);
        localStorage.setItem(this.environment.application_instance + "claim", null);
        localStorage.setItem(this.environment.application_instance + "idTokenExp", null);
        this.notDeconnected = true;
        this.runTimeDataService.updateStore("token", null);
        this.runTimeDataService.updateStore("ConfService", null);
        this.connected = false;
        if (redirectUrl) {
            this.router.navigateByUrl(redirectUrl);
        }
    }
    logout(redirectUrl = "/deconnected") {
        this.internalLogout(null);
        this.oauthService.logOut();
        if (redirectUrl) {
            this.router.navigateByUrl(redirectUrl);
        }
    }
    reconnect() {
        // ???
        this.oauthService.initImplicitFlow();
    }
}
ConfService.ɵfac = function ConfService_Factory(t) { return new (t || ConfService)(ɵngcc0.ɵɵinject(ɵngcc14.HttpClient), ɵngcc0.ɵɵinject(ɵngcc19.OAuthService), ɵngcc0.ɵɵinject(ɵngcc17.Router), ɵngcc0.ɵɵinject(ɵngcc17.ActivatedRoute), ɵngcc0.ɵɵinject(RunTimeDataService), ɵngcc0.ɵɵinject(Environment), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
ConfService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ConfService_Factory() { return new ConfService(i0.ɵɵinject(i1$2.HttpClient), i0.ɵɵinject(i2.OAuthService), i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(RunTimeDataService), i0.ɵɵinject(Environment), i0.ɵɵinject(i0.PLATFORM_ID)); }, token: ConfService, providedIn: "root" });
ConfService.ctorParameters = () => [
    { type: HttpClient },
    { type: OAuthService },
    { type: Router },
    { type: ActivatedRoute },
    { type: RunTimeDataService },
    { type: undefined, decorators: [{ type: Inject, args: [Environment,] }] },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];

class ConnectedGuard {
    constructor(confService, runTimeDataService) {
        this.confService = confService;
        this.runTimeDataService = runTimeDataService;
    }
    canActivate(next, state) {
        // console.log('guard')
        return this.confService.initCon.pipe(filter((data) => data), mergeMap((data) => {
            if (this.confService.connected) {
                return this.runTimeDataService.getObservableStore('ConfService').pipe(filter((d) => d), map((e) => {
                    return true;
                }));
            }
            else {
                this.confService.connect();
                return of(false);
            }
        }));
    }
}
ConnectedGuard.ɵfac = function ConnectedGuard_Factory(t) { return new (t || ConnectedGuard)(ɵngcc0.ɵɵinject(ConfService), ɵngcc0.ɵɵinject(RunTimeDataService)); };
ConnectedGuard.ɵprov = i0.ɵɵdefineInjectable({ factory: function ConnectedGuard_Factory() { return new ConnectedGuard(i0.ɵɵinject(ConfService), i0.ɵɵinject(RunTimeDataService)); }, token: ConnectedGuard, providedIn: "root" });
ConnectedGuard.ctorParameters = () => [
    { type: ConfService },
    { type: RunTimeDataService }
];

class LogUpdateService {
    constructor(updates) {
        updates.available.subscribe((event) => {
            // console.log('current version is', event.current);
            // console.log('available version is', event.available);
        });
        updates.activated.subscribe((event) => {
            // console.log('old version was', event.previous);
            // console.log('new version is', event.current);
        });
    }
    test() {
        // console.log('LogUpdateService') ;
    }
}
LogUpdateService.ɵfac = function LogUpdateService_Factory(t) { return new (t || LogUpdateService)(ɵngcc0.ɵɵinject(ɵngcc18.SwUpdate)); };
LogUpdateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LogUpdateService_Factory() { return new LogUpdateService(i0.ɵɵinject(i1$1.SwUpdate)); }, token: LogUpdateService, providedIn: "root" });
LogUpdateService.ctorParameters = () => [
    { type: SwUpdate }
];

class PromptUpdateService {
    constructor(updates) {
        updates.available.subscribe((event) => {
            // if (promptUser(event)) {
            updates.activateUpdate().then(() => {
                // console.log("reload !!");
                document.location.reload();
            });
            // }
        });
    }
    test() {
        // console.log('PromptUpdateService') ;
    }
}
PromptUpdateService.ɵfac = function PromptUpdateService_Factory(t) { return new (t || PromptUpdateService)(ɵngcc0.ɵɵinject(ɵngcc18.SwUpdate)); };
PromptUpdateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PromptUpdateService_Factory() { return new PromptUpdateService(i0.ɵɵinject(i1$1.SwUpdate)); }, token: PromptUpdateService, providedIn: "root" });
PromptUpdateService.ctorParameters = () => [
    { type: SwUpdate }
];

function stateObj$1() {
    return (target, propertyKey, descriptor = null) => { };
}
function statePop$1() {
    return function (target, propertyKey, descriptor = null) {
        if (delete target[propertyKey]) {
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    if (this.state) {
                        return this.state[propertyKey];
                    }
                    return undefined;
                },
                set: function (value) {
                    if (!this.state) {
                        this.state = {};
                    }
                    this.state[propertyKey] = value;
                },
            });
        }
    };
}

class InfraServiceModule {
    static forRoot(config) {
        return {
            ngModule: InfraServiceModule,
            providers: [
                RunTimeDataService,
                StatesService,
                RouteComponentState,
                UIComponentState,
                OAuthService,
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
                LogUpdateService,
                CheckForUpdateService,
                PromptUpdateService,
                {
                    provide: Environment,
                    useValue: config,
                },
                ConfService,
            ],
        };
    }
}
InfraServiceModule.ɵfac = function InfraServiceModule_Factory(t) { return new (t || InfraServiceModule)(); };
InfraServiceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: InfraServiceModule });
InfraServiceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        StatesService,
        RouteComponentState,
        RunTimeDataService,
        ConfService,
        OAuthService,
    ], imports: [[OAuthModule.forRoot()]] });

function stateObj() {
    return (target, propertyKey, descriptor = null) => {
    };
}
function statePop() {
    return function (target, propertyKey, descriptor = null) {
        // if (!this.state) {
        //     this.state = {  };
        // }
        if (delete target[propertyKey]) {
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    if (this.state) {
                        return this.state[propertyKey];
                    }
                    return undefined;
                },
                set: function (value) {
                    if (!this.state) {
                        this.state = {};
                    }
                    this.state[propertyKey] = value;
                }
            });
        }
    };
}

class FormComponent extends BaseComponent {
    constructor(router, className, activeRoute, uIComponentState, statesService, dialog, snackBar, _loc) {
        super();
        this.router = router;
        this.className = className;
        this.activeRoute = activeRoute;
        this.uIComponentState = uIComponentState;
        this.statesService = statesService;
        this.dialog = dialog;
        this.snackBar = snackBar;
        this._loc = _loc;
        this.state = {};
        this.unVisibleComp = {};
    }
    get isNew() {
        return this._isNew;
    }
    ngOnInit() {
        this.initDataState();
        this.initData();
    }
    //#region Init DataState
    initDataState() {
        this.subscription.add(this.activeRoute.data.subscribe((dataState) => {
            if (!dataState || !dataState.state) {
                return;
            }
            this.initState(dataState.state);
        }));
    }
    initState(state) {
        this.uIComponentState.addToState(state);
        this.uIComponentState.id = this.id;
        Object.assign(this.state, this.uIComponentState.state);
        Object.assign(this.uIComponentState.state, this.state);
        this.state = this.uIComponentState.state;
    }
    //#endregion
    //#region Init Data
    initData() {
        const { id } = this.activeRoute.snapshot.params;
        if (id) {
            this.subscription.add(this.httpServiceBase.get(id).subscribe((dataRes) => {
                this.processDataResponse(id, dataRes);
            }));
        }
    }
    processDataResponse(id, dataRes) {
        if (dataRes.code !== 200) {
            // console.log("err:" + dataRes.message);
            return;
        }
        if (dataRes.response.length === 0) {
            this.initNewForm(id);
        }
        else {
            this.initExistingDataForm(dataRes.response[0]);
        }
    }
    initNewForm(id) {
        this._isNew = true;
        if (this.state.formGroupValue && this.state.formGroupValue._id === id) {
            this.formGroup.patchValue(this.state.formGroupValue);
        }
    }
    initExistingDataForm(data) {
        if (!this.state.formGroupValue) {
            this._isNew = false;
            this.formGroup.patchValue(data);
        }
        else if (this.state.formGroupValue._id !== data._id) {
            this.formGroup.patchValue(data);
        }
        else {
            // TODO : A modifier. Avec cette technique, on corrige le bug
            // du non affichage au second coup
            // mais on perd la mémorisation des states
            this.formGroup.patchValue(data);
        }
        // else if (this.state.formGroupValue) {
        //   this.formGroup.patchValue(this.state.formGroupValue);
        // }
    }
    //#endregion
    //#region duplicate
    duplicate() {
        let newId = ObjectId$1.stringObjectId();
        let newName = `${this.formGroup.value.name} (Duplicate)`;
        this.formGroup.value._id = newId;
        if (this.formGroup.value && this.formGroup.value.name) {
            this.formGroup.value.name = newName;
        }
        this.httpServiceBase
            .post(this.formGroup.value)
            .pipe(ApiHelper.resultToObj('Duplication Error'), switchMap((obj) => {
            if (obj) {
                return this.activeRoute.url;
            }
        }))
            .subscribe((url) => {
            if (url.length > 0) {
                url[url.length - 1].path = newId;
            }
            const urlPath = url.map((u) => u.path);
            urlPath.unshift('data');
            urlPath.unshift('/');
            this.snackBar.open('Produit dupliqué avec succès', '×', {
                panelClass: 'success',
                verticalPosition: 'top',
                duration: 3000,
            });
            this.router.navigate(['/']).then((res) => {
                this.router.navigate(urlPath);
            });
        });
    }
    //#endregion
    //#region Save
    save() {
        const val = this.formGroup.getRawValue();
        // console.log("doc saved", val);
        if (this.isNew) {
            this.create(val);
        }
        else {
            this.update(val);
        }
    }
    create(val) {
        this.subscription.add(this.httpServiceBase
            .post(val)
            .pipe(ApiHelper.resultToObjWEmptyError('Can not create document'))
            .subscribe(() => {
            this.snackBar.open('Document créé !', null, {
                duration: 2000,
            });
            setTimeout(() => this._loc.back(), 1000);
        }, (err) => {
            this.snackBar.open(err.message, null, {
                duration: 2000,
            });
        }));
    }
    update(val) {
        this.subscription.add(this.httpServiceBase
            .put(val)
            .pipe(ApiHelper.resultToObjWEmptyError('Can not save document'))
            .subscribe(() => {
            this.snackBar.open('Document enregistré !', null, {
                duration: 2000,
            });
            setTimeout(() => this._loc.back(), 1000);
        }, (err) => {
            this.snackBar.open(err.message, null, {
                duration: 2000,
            });
        }));
    }
    //#endregion
    //#region Delete
    delete() {
        this.openDeleteDialog().then((res) => {
            if (res === 'OUI') {
                this.confirmDelete();
            }
            else {
                // console.log("file deletion canceled");
            }
        });
    }
    openDeleteDialog() {
        const dialogRef = this.dialog.open(ModaleComponent, {
            width: '400px',
            data: {
                title: 'Etes-vous certain de vouloir supprimer cet élément ?',
                text: 'Opération irréversible',
                options: ['OUI', 'NON'],
            },
        });
        return new Promise((resolve, reject) => {
            dialogRef.afterClosed().subscribe((result) => {
                // console.log("The dialog was closed", result);
                resolve(result);
            });
        });
    }
    confirmDelete() {
        this.subscription.add(this.httpServiceBase.delete(this.formGroup.getRawValue()._id).subscribe((data) => {
            if (data.code === 200) {
                this.statesService.navigateBack();
            }
            else {
                throw new Error(data.message);
            }
        }, (err) => { }));
    }
    //#endregion
    ngOnDestroy() {
        if (this.formGroup) {
            this.state.formGroupValue = this.formGroup.getRawValue();
        }
    }
}
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.Router), ɵngcc0.ɵɵdirectiveInject(String), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(UIComponentState), ɵngcc0.ɵɵdirectiveInject(StatesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.MatDialog), ɵngcc0.ɵɵdirectiveInject(ɵngcc20.MatSnackBar), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Location)); };
FormComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormComponent, inputs: { id: "id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
FormComponent.ctorParameters = () => [
    { type: Router },
    { type: String },
    { type: ActivatedRoute },
    { type: UIComponentState },
    { type: StatesService },
    { type: MatDialog },
    { type: MatSnackBar },
    { type: Location }
];
FormComponent.propDecorators = {
    id: [{ type: Input }]
};
__decorate([
    statePop()
], FormComponent.prototype, "unVisibleComp", void 0);

class ListComponent extends BaseComponent {
    constructor(router, className, activeRoute, uIComponentState, clickRedirectPath = '/edit') {
        super();
        this.router = router;
        this.className = className;
        this.activeRoute = activeRoute;
        this.uIComponentState = uIComponentState;
        this.clickRedirectPath = clickRedirectPath;
        this.defaultFilterBase = '*/';
        this.state = {};
        this.pageSizeOptions = [5, 10, 20, 50];
        this.isLoadingResults = true;
        this.displayedColumns = null;
        this.pageSize = 50;
        this.pageIndex = 0;
        this.dataLength = 0;
        this._filterBase = this.defaultFilterBase;
        this.filter = new BehaviorSubject(this.filterBase);
        this.data = new MatTableDataSource([]);
        this.paginatorBehaviors = new BehaviorSubject(null);
        this.sortBehaviors = new BehaviorSubject(null);
    }
    get filterBase() {
        return this._filterBase;
    }
    set filterBase(value) {
        this._filterBase = value;
        this.filter.next(value);
    }
    filterTextToFilterUrl(text) {
        if (!text) {
            return this.filterBase;
        }
        let searchUri = '';
        if (this.filterBase !== this.defaultFilterBase) {
            searchUri = this.filterBase;
        }
        // ajouter dan le serveur la possibilité d interpreter l'encodage uri au moment de la recherche
        // car pour l'instant pas moyen d'echaper les caractere sans une interpretation de l'url
        // d'ou une génération d'erreur
        const searchTxtPatern = text
            .replace(/[-[\]{}()*+?.,\\^$|#]/g, '.')
            .replace(/\/|\\\\/gi, '.');
        let nb = 0;
        this.table.displayedColumns.forEach((coll) => {
            if (this.table.columnsType &&
                (this.table.columnsType[coll] === 'string' ||
                    this.table.columnsType[coll] === 'texte' ||
                    this.table.columnsType[coll] === 'htmltexte')) {
                searchUri += `${coll}/${searchTxtPatern}/i/$regex/`;
                nb += 1;
            }
        });
        for (let i = 1; i < nb; i++) {
            searchUri += '$or/';
        }
        if (this.filterBase !== this.defaultFilterBase) {
            searchUri += '&/';
        }
        return searchUri;
    }
    applyFilter(text) {
        let pag = this.paginatorBehaviors.value;
        pag.pageIndex = 0;
        this.pageIndex = 0;
        this.paginatorBehaviors.next(pag);
        if (text) {
            this.filter.next(this.filterTextToFilterUrl(text));
        }
        else {
            this.filter.next(this.filterBase);
        }
    }
    sortChange(event) {
        let pag = this.paginatorBehaviors.value;
        pag.pageIndex = 0;
        this.pageIndex = 0;
        this.paginatorBehaviors.next(pag);
        this.sortBehaviors.next(event);
        this.isLoadingResults = true;
    }
    paginatorChange(event) {
        this.paginatorBehaviors.next(event);
        this.isLoadingResults = true;
    }
    initDataObs() {
        return merge(this.sortBehaviors, this.paginatorBehaviors, this.filter).pipe(debounceTime(200), switchMap(() => {
            let endQuery = '';
            if (this.filter.value) {
                endQuery = this.filter.value;
            }
            if (this.sortBehaviors.value.active !== '' &&
                this.sortBehaviors.value.active) {
                endQuery += `${this.sortBehaviors.value.active}/`;
                if (this.sortBehaviors.value.direction === 'desc') {
                    endQuery += `-1/$sort/`;
                }
                else {
                    endQuery += `1/$sort/`;
                }
            }
            endQuery += `${this.paginatorBehaviors.value.pageIndex *
                this.paginatorBehaviors.value.pageSize}/$skip/`;
            endQuery += `${this.paginatorBehaviors.value.pageSize}/$limit/`;
            // console.log("initDataObs", endQuery);
            return this.httpServiceBase.get(`${endQuery}`);
        }));
    }
    ngOnInit() {
        // console.log("ngInit ListComponent");
        this.dataObs = this.initDataObs();
        this.subscription.add(this.activeRoute.data.subscribe((data) => {
            // console.log("this.activeRoute", data);
            if (data && data.state) {
                // console.log("data.state", data.state);
                this.uIComponentState.addToState(data.state);
                this.uIComponentState.id = this.id;
                Object.assign(this.state, this.uIComponentState.state);
                Object.assign(this.uIComponentState.state, this.state);
                this.state = this.uIComponentState.state;
                this.state.isNew = false;
                const pEvt = new PageEvent();
                pEvt.length = this.dataLength;
                pEvt.pageIndex = this.pageIndex;
                pEvt.pageSize = this.pageSize;
                this.paginatorBehaviors.next(pEvt);
                const sEvt = {
                    active: this.sortColumn,
                    direction: this.sortDirection,
                };
                this.sortBehaviors.next(sEvt);
                this.dataObs.subscribe((resp) => {
                    // console.log("dataObs", resp);
                    if (resp.code === 200) {
                        this.pageSize = resp.meta.pageSize;
                        this.dataLength = resp.meta.count;
                        this.pageIndex = Math.floor(resp.meta.offset / resp.meta.pageSize);
                        this.data.data = resp.response;
                        this.uIComponentState.state.pageSize = resp.meta.pageSize;
                        // console.log("this.data", this.data);
                    }
                    else {
                        this.data.data = [];
                    }
                    this.isLoadingResults = false;
                });
            }
        }));
    }
    ngOnDestroy() {
        this.uIComponentState.unmount();
    }
    rowClicked(row) {
        if (row._class) {
            this.router.navigate([`${row._class}/edit/${row._id}`], {
                relativeTo: this.activeRoute.parent,
            });
        }
        else {
            this.router.navigate([`${this.className}/edit/${row._id}`], {
                relativeTo: this.activeRoute.parent,
            });
        }
    }
}
ListComponent.ɵfac = function ListComponent_Factory(t) { return new (t || ListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.Router), ɵngcc0.ɵɵdirectiveInject(String), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(UIComponentState), ɵngcc0.ɵɵdirectiveInject(String)); };
ListComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ListComponent, inputs: { id: "id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
ListComponent.ctorParameters = () => [
    { type: Router },
    { type: String },
    { type: ActivatedRoute },
    { type: UIComponentState },
    { type: String }
];
ListComponent.propDecorators = {
    id: [{ type: Input }]
};
__decorate([
    statePop()
], ListComponent.prototype, "displayedColumns", void 0);
__decorate([
    statePop()
], ListComponent.prototype, "pageSize", void 0);
__decorate([
    statePop()
], ListComponent.prototype, "pageIndex", void 0);
__decorate([
    statePop()
], ListComponent.prototype, "dataLength", void 0);
__decorate([
    statePop()
], ListComponent.prototype, "sortDirection", void 0);
__decorate([
    statePop()
], ListComponent.prototype, "sortColumn", void 0);

class UiForm extends BaseComponent {
    // TET
    constructor(uIComponentState) {
        super();
        this.uIComponentState = uIComponentState;
        this.state = {};
        this.unVisibleComp = {};
        this.disableComp = {};
    }
    ngOnInit() {
        this.uIComponentState.id = this.id;
        Object.assign(this.state, this.uIComponentState.state);
        Object.assign(this.uIComponentState.state, this.state);
        this.state = this.uIComponentState.state;
        this.initDisableComp();
    }
    propState(key, data) {
        setTimeout(() => {
            this.state[key] = data;
        }, 100);
    }
    initDisableComp() {
        if (!this.disableComp) {
            return;
        }
        Object.keys(this.formGroup.controls).forEach(key => {
            const isDisabledExists = !!this.disableComp[key] && (typeof this.disableComp[key] === 'boolean');
            if (!isDisabledExists) {
                return;
            }
            if (this.disableComp[key] === true) {
                this.formGroup.controls[key].disable();
            }
            else {
                this.formGroup.controls[key].enable();
            }
        });
    }
}
UiForm.ɵfac = function UiForm_Factory(t) { return new (t || UiForm)(ɵngcc0.ɵɵdirectiveInject(UIComponentState)); };
UiForm.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiForm, inputs: { unVisibleComp: "unVisibleComp", formGroup: "formGroup", id: "id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
UiForm.ctorParameters = () => [
    { type: UIComponentState }
];
UiForm.propDecorators = {
    formGroup: [{ type: Input }],
    id: [{ type: Input }],
    unVisibleComp: [{ type: Input }]
};
__decorate([
    statePop$1()
], UiForm.prototype, "unVisibleComp", void 0);
__decorate([
    statePop$1()
], UiForm.prototype, "disableComp", void 0);

class UiList extends BaseComponent {
    constructor() {
        super();
        this._displayedColumns = null;
        this.columnsType = null;
        this.isLoadingResults = true;
        this.sortChange = new EventEmitter();
        this.rowClicked = new EventEmitter();
    }
    get displayedColumns() {
        return this._displayedColumns;
    }
    set displayedColumns(value) {
        if (value) {
            this._displayedColumns = value;
        }
    }
    get sortDirection() {
        return this._sortDirection;
    }
    set sortDirection(value) {
        this._sortDirection = value;
    }
    get sortColumn() {
        return this._sortColumn;
    }
    set sortColumn(value) {
        this._sortColumn = value;
    }
    ngOnInit() {
        this.data.sort = this.sort;
    }
    sortEvt(evt) {
        this.sortChange.emit(evt);
    }
    rowClick($event, row) {
        // // console.log(row) ;
        this.rowClicked.emit(row);
    }
}
UiList.ɵfac = function UiList_Factory(t) { return new (t || UiList)(); };
UiList.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiList, viewQuery: function UiList_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatSort, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { columnsType: "columnsType", isLoadingResults: "isLoadingResults", displayedColumns: "displayedColumns", sortDirection: "sortDirection", sortColumn: "sortColumn", data: "data" }, outputs: { sortChange: "sortChange", rowClicked: "rowClicked" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
UiList.ctorParameters = () => [];
UiList.propDecorators = {
    displayedColumns: [{ type: Input }],
    columnsType: [{ type: Input }],
    data: [{ type: Input }],
    isLoadingResults: [{ type: Input }],
    sortDirection: [{ type: Input }],
    sortColumn: [{ type: Input }],
    sort: [{ type: ViewChild, args: [MatSort, { static: true },] }],
    sortChange: [{ type: Output, args: ['sortChange',] }],
    rowClicked: [{ type: Output, args: ['rowClicked',] }]
};

class UiListMultiSelect extends BaseComponent {
    constructor() {
        super();
        this.displayedColumns = ['select'];
        this.data = [];
        this.isLoadingResults = true;
        this.arrSelection = [];
        this.sortChange = new EventEmitter();
        this.selection = new SelectionModel(true, this.arrSelection);
    }
    remove(fruit) { }
    isAllSelected() {
        return false;
    }
    ngOnInit() { }
    sortEvt(evt) {
        this.sortChange.emit(evt);
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.data.forEach((row) => this.selection.select(row));
    }
}
UiListMultiSelect.ɵfac = function UiListMultiSelect_Factory(t) { return new (t || UiListMultiSelect)(); };
UiListMultiSelect.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiListMultiSelect, viewQuery: function UiListMultiSelect_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatSort, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { displayedColumns: "displayedColumns", data: "data", isLoadingResults: "isLoadingResults", arrSelection: "arrSelection", sortDirection: "sortDirection", sortColumn: "sortColumn", selectable: "selectable", removable: "removable" }, outputs: { sortChange: "sortChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
UiListMultiSelect.ctorParameters = () => [];
UiListMultiSelect.propDecorators = {
    displayedColumns: [{ type: Input }],
    data: [{ type: Input }],
    isLoadingResults: [{ type: Input }],
    sortDirection: [{ type: Input }],
    sortColumn: [{ type: Input }],
    sort: [{ type: ViewChild, args: [MatSort, { static: true },] }],
    sortChange: [{ type: Output, args: ['sortChange',] }],
    arrSelection: [{ type: Input }],
    selectable: [{ type: Input }],
    removable: [{ type: Input }]
};

class UiListSelect extends BaseComponent {
    constructor() {
        super();
        this.displayedColumns = [];
        this.data = [];
        this.isLoadingResults = true;
        this.arrSelection = [];
        this.sortChange = new EventEmitter();
        this.selection = new SelectionModel(true, this.arrSelection);
    }
    remove(fruit) { }
    ngOnInit() { }
    sortEvt(evt) {
        this.sortChange.emit(evt);
    }
    updateSelect(row) {
        this.selection.clear();
        this.selection.select(row);
    }
}
UiListSelect.ɵfac = function UiListSelect_Factory(t) { return new (t || UiListSelect)(); };
UiListSelect.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiListSelect, viewQuery: function UiListSelect_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatSort, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { displayedColumns: "displayedColumns", data: "data", isLoadingResults: "isLoadingResults", arrSelection: "arrSelection", sortDirection: "sortDirection", sortColumn: "sortColumn", selectable: "selectable", removable: "removable" }, outputs: { sortChange: "sortChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
UiListSelect.ctorParameters = () => [];
UiListSelect.propDecorators = {
    displayedColumns: [{ type: Input }],
    data: [{ type: Input }],
    isLoadingResults: [{ type: Input }],
    sortDirection: [{ type: Input }],
    sortColumn: [{ type: Input }],
    sort: [{ type: ViewChild, args: [MatSort, { static: true },] }],
    sortChange: [{ type: Output, args: ['sortChange',] }],
    arrSelection: [{ type: Input }],
    selectable: [{ type: Input }],
    removable: [{ type: Input }]
};

class UiListSubDoc extends BaseComponent {
    constructor(uIComponentState) {
        super();
        this.uIComponentState = uIComponentState;
        this.state = {};
        this.columnsToDisplay = ['actions'];
        this.unVisibleComp = {};
        this.data = new MatTableDataSource();
    }
    get inputData() {
        return this._inputData;
    }
    set inputData(value) {
        this._inputData = value;
        this.subscription.add(this._inputData.valueChanges.subscribe((val) => {
            this.data.data = this._inputData.value;
            // console.log("imput data " + this._inputData.controls.length);
            if (this.slctTable) {
                this.slctTable.renderRows();
            }
        }));
        this.data.data = this._inputData.value;
    }
    ngOnInit() {
        this.uIComponentState.id = this.id;
        Object.assign(this.state, this.uIComponentState.state);
        Object.assign(this.uIComponentState.state, this.state);
        this.state = this.uIComponentState.state;
        // console.log("updt state");
    }
    editTemplate($event, selector) {
        this.expandedElement = this.expandedElement === selector ? null : selector;
        this.slctTable.renderRows();
        $event.stopPropagation();
    }
    deleteTemplate($event, selector) {
        this.inputData.controls.splice(this.inputData.controls.indexOf(selector), 1);
        this.slctTable.renderRows();
        $event.stopPropagation();
    }
    saveTemplate($event, selector) {
        this.expandedElement = null;
        $event.stopPropagation();
    }
    addItem() {
        this.inputData.push(this.newElement);
        this.newElement = new this.FormClass();
        this.newSlctPanel.close();
        this.slctTable.renderRows();
    }
    drop(event) {
        // console.log(event);
        moveItemInArray(this.inputData.controls, this.inputData.controls.indexOf(event.item.data), event.currentIndex);
        this.slctTable.renderRows();
    }
    fieldClassChange(evt, element) { }
}
UiListSubDoc.ɵfac = function UiListSubDoc_Factory(t) { return new (t || UiListSubDoc)(ɵngcc0.ɵɵdirectiveInject(UIComponentState)); };
UiListSubDoc.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiListSubDoc, viewQuery: function UiListSubDoc_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(_c4, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.slctTable = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.newSlctPanel = _t.first);
    } }, inputs: { unVisibleComp: "unVisibleComp", inputData: "inputData", label: "label", id: "id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
UiListSubDoc.ctorParameters = () => [
    { type: UIComponentState }
];
UiListSubDoc.propDecorators = {
    inputData: [{ type: Input }],
    label: [{ type: Input }],
    slctTable: [{ type: ViewChild, args: ['selectorTable', { static: true },] }],
    newSlctPanel: [{ type: ViewChild, args: ['newSelector', { static: true },] }],
    id: [{ type: Input }],
    unVisibleComp: [{ type: Input }]
};
__decorate([
    statePop$1()
], UiListSubDoc.prototype, "columnsToDisplay", void 0);
__decorate([
    statePop$1()
], UiListSubDoc.prototype, "unVisibleComp", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BooleanListComponent, [{
        type: Component,
        args: [{
                selector: 'app-boolean-list',
                template: "<mat-accordion>\n    <mat-expansion-panel (opened)=\"panelOpenState = true\"\n    (closed)=\"panelOpenState = false\">\n      <mat-expansion-panel-header>\n        <mat-panel-title>\n            {{label}}\n        </mat-panel-title>\n        <mat-panel-description>\n            <ng-container *ngIf=\"openState\">\n\n            </ng-container>\n            <ng-container *ngIf=\"!openState\">\n                    <ng-container *ngFor=\"let frmCtl of formArr.controls\">\n                        {{frmCtl.value}} \n                    </ng-container>\n            </ng-container>\n        </mat-panel-description>\n      </mat-expansion-panel-header>\n  \n      <ng-template matExpansionPanelContent>\n      <mat-list>\n            <mat-list-item *ngFor=\"let frmCtl of formArr.controls\">\n                    {{ frmCtl.value}}\n                    <mat-action-list>\n                            <button mat-list-item > edit </button>\n                            <button mat-list-item > delete </button>\n                          </mat-action-list>\n            </mat-list-item>\n     </mat-list>\n    </ng-template>\n  \n\n    </mat-expansion-panel>\n    \n  </mat-accordion>",
                styles: [""]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], formArr: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateListComponent, [{
        type: Component,
        args: [{
                selector: 'app-date-list',
                template: "<p>date-list works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HtmlListComponent, [{
        type: Component,
        args: [{
                selector: 'app-html-list',
                template: "<p>html-list works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModaleComponent, [{
        type: Component,
        args: [{
                selector: 'app-modale',
                template: "<h1 mat-dialog-title>{{data.title}}</h1>\n<div mat-dialog-content>\n  <p>{{data.text}}</p>\n</div>\n<div mat-dialog-actions *ngIf=\"data.options\">\n  <button mat-button *ngFor=\"let opt of data.options\" [mat-dialog-close]=\"opt\">{{opt}}</button>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberListComponent, [{
        type: Component,
        args: [{
                selector: 'app-number-list',
                template: "<mat-accordion>\n    <mat-expansion-panel (opened)=\"openState = true\" (closed)=\"openState = false\">\n        <mat-expansion-panel-header>\n            <mat-panel-title>\n                {{label}}\n            </mat-panel-title>\n            <mat-panel-description>\n                <ng-container *ngIf=\"openState\">\n\n                </ng-container>\n                <ng-container *ngIf=\"!openState && formArr\">\n                    <ng-container *ngFor=\"let frmCtl of formArr.controls\">\n                        {{frmCtl.value}},\n                    </ng-container>\n                </ng-container>\n            </mat-panel-description>\n        </mat-expansion-panel-header>\n\n        <ng-template matExpansionPanelContent>\n            <mat-list *ngIf=\"formArr\">\n                <mat-list-item *ngFor=\"let frmCtl of formArr.controls\">\n                    <span fxFlex>{{ frmCtl.value}}</span>\n                    <!-- <button mat-button> edit </button> -->\n                    <button mat-button (click)=\"delete(frmCtl)\"> delete </button>\n                </mat-list-item>\n            </mat-list>\n            <mat-form-field appearance=\"fill\">\n                <mat-label>nouveau</mat-label>\n\n                <input matInput type=\"number\" placeholder=\"\" [formControl]=\"newCtrl\"\n                    *ngIf=\" (!select) || select.length === 0\">\n                <mat-select placeholder=\"Select\" [formControl]=\"newCtrl\" *ngIf=\"select && select.length > 0\"\n                    (valueChange)=\"addNew()\">\n                    <mat-option [value]=\"val\" *ngFor=\"let val of select\">{{val}}</mat-option>\n                </mat-select>\n                <button mat-button matSuffix mat-icon-button aria-label=\"add\" (click)=\"addNew()\"\n                    *ngIf=\" (!select) || select.length === 0\">\n                    <mat-icon>add</mat-icon>\n                </button>\n            </mat-form-field>\n        </ng-template>\n\n\n    </mat-expansion-panel>\n\n</mat-accordion>",
                styles: [""]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], select: [{
            type: Input
        }], formArr: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ObjectListComponent, [{
        type: Component,
        args: [{
                selector: 'app-object-list',
                template: "<p>object-list works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordComponent, [{
        type: Component,
        args: [{
                selector: 'app-password',
                template: "<p>password works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordListComponent, [{
        type: Component,
        args: [{
                selector: 'app-password-list',
                template: "<p>password-list works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: ɵngcc13.DomSanitizer }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StringListComponent, [{
        type: Component,
        args: [{
                selector: 'app-string-list',
                template: "<mat-accordion>\n  <mat-expansion-panel (opened)=\"openState = true\" (closed)=\"openState = false\">\n    <mat-expansion-panel-header>\n      <mat-panel-title>\n        {{label}}\n      </mat-panel-title>\n      <mat-panel-description>\n        <ng-container *ngIf=\"openState\">\n\n        </ng-container>\n        <ng-container *ngIf=\"!openState && formArr\">\n          <ng-container *ngFor=\"let frmCtl of formArr.controls\">\n            {{frmCtl.value}}, \n          </ng-container>\n        </ng-container>\n      </mat-panel-description>\n    </mat-expansion-panel-header>\n\n    <ng-template matExpansionPanelContent>\n      <mat-list *ngIf=\"formArr\">\n        <mat-list-item *ngFor=\"let frmCtl of formArr.controls\">\n          <span fxFlex>{{ frmCtl.value}}</span>\n          <!-- <button mat-button> edit </button> -->\n          <button mat-button (click)=\"delete(frmCtl)\"> delete </button>\n        </mat-list-item>\n      </mat-list>\n      <mat-form-field appearance=\"fill\" >\n        <mat-label>nouveau</mat-label>\n        \n        <input matInput placeholder=\"\" [formControl]=\"newCtrl\" *ngIf=\" (!select) || select.length === 0\" >\n        <mat-select placeholder=\"Select\" [formControl]=\"newCtrl\" *ngIf=\"select && select.length > 0\" (valueChange)=\"addNew()\">\n          <mat-option [value]=\"val\" *ngFor=\"let val of select\" >{{val}}</mat-option>\n        </mat-select>\n        <button mat-button matSuffix mat-icon-button aria-label=\"add\" (click)=\"addNew()\" *ngIf=\" (!select) || select.length === 0\" >\n          <mat-icon>add</mat-icon>\n        </button>\n      </mat-form-field>\n    </ng-template>\n\n\n  </mat-expansion-panel>\n\n</mat-accordion>",
                styles: [""]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], select: [{
            type: Input
        }], formArr: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TexteListComponent, [{
        type: Component,
        args: [{
                selector: 'app-texte-list',
                template: "<p>texte-list works!</p>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Adaptater, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseComponent, [{
        type: Directive
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiRefComponent, [{
        type: Component,
        args: [{
                selector: 'app-ui-ref',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: Adaptater }]; }, { colName: [{
            type: Input
        }], idRef: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiUploaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc14.HttpClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiUploaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-ui-uploader',
                template: "<div fxLayout=\"column\" fxLayoutAlign=\"start center\" class=\"container\">\n    <div class=\"img-res\">\n        <p *ngIf=\"value?.originalName\">Name: {{value.originalName}}</p>\n        <img *ngIf=\"value\" [src]=\"value?.url\" />\n        <img *ngIf=\"!value\" src=\"https://cdn.blacksoft.ca/assets/blacksoft/img/empty.png\" />\n    </div>\n    <div class=\"img-ul\">\n\n        <div fxLayout=\"row wrap\" fxLayoutAlign=\"space-around center\" fxLayoutGap=\"10px\">\n            <button type=\"button\" fxFlex=\"calc(60% - 10px)\" mat-raised-button (click)=\"fileInput.click()\">\n                S\u00E9lectionner un fichier\n            </button>\n            <input hidden #fileInput type=\"file\" name=\"files\" (change)=\"onFileSelect($event)\" [accept]=\"accept\"/>\n\n            <button fxFlex=\"40\" mat-raised-button type=\"button\" (click)=\"startUpload()\"\n                [disabled]=\"!!!fileToUpload\">T\u00E9l\u00E9charger</button>\n        </div>\n\n        <p class=\"or-txt\">ou</p>\n\n        <form [formGroup]=\"urlForm\" fxLayout=\"row wrap\" fxLayoutAlign=\"space-around center\" fxLayoutGap=\"10px\">\n\n            <mat-form-field fxFlex=\"calc(60% - 10px)\">\n                <mat-label>Coller une URL</mat-label>\n                <input matInput type=\"text\" formControlName=\"url\" (change)=\"onNewUrl()\" required />\n            </mat-form-field>\n            <button class=\"url-upload\" fxFlex=\"40\" mat-raised-button type=\"button\" (click)=\"startUploadUrl()\"\n                [disabled]=\"!urlForm.valid\">T\u00E9l\u00E9charger</button>\n\n        </form>\n\n        <p>{{message | async}}</p>\n\n        <mat-progress-bar *ngIf=\"fileToUpload\" mode=\"determinate\" [value]=\"progress | async\"></mat-progress-bar>\n\n    </div>\n</div>\n",
                providers: [
                    UiUploaderService,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => UiUploaderComponent),
                        multi: true
                    },
                    {
                        provide: MatFormFieldControl,
                        useExisting: UiUploaderComponent
                    },
                ],
                styles: [".container{width:500px}.container .img-res{text-align:center;height:400px;margin-bottom:20px}.container .img-res img{width:400px;height:400px;object-fit:cover}.container .img-ul{margin-top:20px;text-align:center;padding:10px}.container .img-ul .or-txt{margin-top:10px;font-size:larger}.container .url-upload{margin-bottom:15px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc15.FocusMonitor }, { type: UiUploaderService, decorators: [{
                type: Self
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc6.MatFormField, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_FORM_FIELD]
            }] }, { type: Adaptater }]; }, { accept: [{
            type: Input
        }], limitSize: [{
            type: Input
        }], id: [{
            type: HostBinding
        }], fsoFileUrl: [{
            type: Input
        }], myFormGroup: [{
            type: Input
        }], value: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], shouldLabelFloat: [{
            type: HostBinding,
            args: ['class.floating']
        }], required: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                entryComponents: [],
                declarations: [
                    PasswordComponent,
                    ObjectListComponent,
                    TexteListComponent,
                    StringListComponent,
                    PasswordListComponent,
                    NumberListComponent,
                    HtmlListComponent,
                    DateListComponent,
                    ModaleComponent,
                    BooleanListComponent,
                    SafePipe,
                    UiUploaderComponent,
                    UiRefComponent,
                ],
                imports: [
                    CommonModule,
                    MatSortModule,
                    MatTableModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatExpansionModule,
                    MatSnackBarModule,
                    MatListModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatSelectModule,
                    MatProgressSpinnerModule,
                    MatProgressBarModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    FormsModule,
                    FlexLayoutModule,
                ],
                exports: [
                    CommonModule,
                    MatSortModule,
                    MatTableModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatExpansionModule,
                    MatSnackBarModule,
                    MatListModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatSelectModule,
                    MatProgressSpinnerModule,
                    MatProgressBarModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    FormsModule,
                    FlexLayoutModule,
                    PasswordComponent,
                    ObjectListComponent,
                    TexteListComponent,
                    StringListComponent,
                    PasswordListComponent,
                    NumberListComponent,
                    HtmlListComponent,
                    DateListComponent,
                    ModaleComponent,
                    BooleanListComponent,
                    SafePipe,
                    UiUploaderComponent,
                    UiRefComponent,
                ],
                providers: [UiUploaderService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedModule, { declarations: function () { return [PasswordComponent, ObjectListComponent, TexteListComponent, StringListComponent, PasswordListComponent, NumberListComponent, HtmlListComponent, DateListComponent, ModaleComponent, BooleanListComponent, SafePipe, UiUploaderComponent, UiRefComponent]; }, imports: function () { return [CommonModule,
        MatSortModule,
        MatTableModule,
        MatDialogModule,
        MatButtonModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatListModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule]; }, exports: function () { return [CommonModule,
        MatSortModule,
        MatTableModule,
        MatDialogModule,
        MatButtonModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatListModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule, PasswordComponent, ObjectListComponent, TexteListComponent, StringListComponent, PasswordListComponent, NumberListComponent, HtmlListComponent, DateListComponent, ModaleComponent, BooleanListComponent, SafePipe, UiUploaderComponent, UiRefComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddPipe, [{
        type: Pipe,
        args: [{ name: 'amAdd' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'amDateFormat' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DifferencePipe, [{
        type: Pipe,
        args: [{ name: 'amDifference' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FromUnixPipe, [{
        type: Pipe,
        args: [{ name: 'amFromUnix' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ParsePipe, [{
        type: Pipe,
        args: [{ name: 'amParse' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SubtractPipe, [{
        type: Pipe,
        args: [{ name: 'amSubtract' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DayjsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AddPipe,
                    DateFormatPipe,
                    DifferencePipe,
                    FromUnixPipe,
                    ParsePipe,
                    SubtractPipe,
                ],
                exports: [AddPipe,
                    DateFormatPipe,
                    DifferencePipe,
                    FromUnixPipe,
                    ParsePipe,
                    SubtractPipe,]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DayjsModule, { declarations: [AddPipe, DateFormatPipe, DifferencePipe, FromUnixPipe, ParsePipe, SubtractPipe], exports: [AddPipe, DateFormatPipe, DifferencePipe, FromUnixPipe, ParsePipe, SubtractPipe] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoCompleteComponent, [{
        type: Directive
    }], function () { return []; }, { filteredData: [{
            type: Input
        }], formArr: [{
            type: Input
        }], formCtrl: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], userInput: [{
            type: ViewChild,
            args: ['UserInput', { static: true }]
        }], matAutocomplete: [{
            type: ViewChild,
            args: ['auto', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StatesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc17.Router }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RouteComponentState, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: StatesService }, { type: ɵngcc17.Router }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UIComponentState, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: UIComponentState, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RunTimeDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: RunTimeDataService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckForUpdateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc18.SwUpdate }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: ɵngcc14.HttpClient }, { type: ɵngcc19.OAuthService }, { type: ɵngcc17.Router }, { type: ɵngcc17.ActivatedRoute }, { type: RunTimeDataService }, { type: undefined, decorators: [{
                type: Inject,
                args: [Environment]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConnectedGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfService }, { type: RunTimeDataService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LogUpdateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc18.SwUpdate }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PromptUpdateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc18.SwUpdate }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfraServiceModule, [{
        type: NgModule,
        args: [{
                imports: [OAuthModule.forRoot()],
                declarations: [],
                entryComponents: [],
                providers: [
                    StatesService,
                    RouteComponentState,
                    RunTimeDataService,
                    ConfService,
                    OAuthService,
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InfraServiceModule, { imports: [ɵngcc19.OAuthModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc17.Router }, { type: String }, { type: ɵngcc17.ActivatedRoute }, { type: UIComponentState }, { type: StatesService }, { type: ɵngcc4.MatDialog }, { type: ɵngcc20.MatSnackBar }, { type: ɵngcc2.Location }]; }, { id: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc17.Router }, { type: String }, { type: ɵngcc17.ActivatedRoute }, { type: UIComponentState }, { type: String }]; }, { id: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiForm, [{
        type: Directive
    }], function () { return [{ type: UIComponentState }]; }, { unVisibleComp: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiList, [{
        type: Directive
    }], function () { return []; }, { columnsType: [{
            type: Input
        }], isLoadingResults: [{
            type: Input
        }], sortChange: [{
            type: Output,
            args: ['sortChange']
        }], rowClicked: [{
            type: Output,
            args: ['rowClicked']
        }], displayedColumns: [{
            type: Input
        }], sortDirection: [{
            type: Input
        }], sortColumn: [{
            type: Input
        }], data: [{
            type: Input
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiListMultiSelect, [{
        type: Directive
    }], function () { return []; }, { displayedColumns: [{
            type: Input
        }], data: [{
            type: Input
        }], isLoadingResults: [{
            type: Input
        }], arrSelection: [{
            type: Input
        }], sortChange: [{
            type: Output,
            args: ['sortChange']
        }], sortDirection: [{
            type: Input
        }], sortColumn: [{
            type: Input
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }], selectable: [{
            type: Input
        }], removable: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiListSelect, [{
        type: Directive
    }], function () { return []; }, { displayedColumns: [{
            type: Input
        }], data: [{
            type: Input
        }], isLoadingResults: [{
            type: Input
        }], arrSelection: [{
            type: Input
        }], sortChange: [{
            type: Output,
            args: ['sortChange']
        }], sortDirection: [{
            type: Input
        }], sortColumn: [{
            type: Input
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }], selectable: [{
            type: Input
        }], removable: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiListSubDoc, [{
        type: Directive
    }], function () { return [{ type: UIComponentState }]; }, { unVisibleComp: [{
            type: Input
        }], inputData: [{
            type: Input
        }], label: [{
            type: Input
        }], slctTable: [{
            type: ViewChild,
            args: ['selectorTable', { static: true }]
        }], newSlctPanel: [{
            type: ViewChild,
            args: ['newSelector', { static: true }]
        }], id: [{
            type: Input
        }] }); })();

class PageTitleService {
    constructor() {
        this.titleEvent = new EventEmitter();
    }
    setPageTitle(s) {
        this.titleEvent.emit(s);
    }
}
PageTitleService.ɵfac = function PageTitleService_Factory(t) { return new (t || PageTitleService)(); };
PageTitleService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PageTitleService_Factory() { return new PageTitleService(); }, token: PageTitleService, providedIn: "root" });
PageTitleService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageTitleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/*
 * Public API Surface of my-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Adaptater, ApiHelper, AutoCompleteComponent, BaseComponent, BooleanListComponent, CheckForUpdateService, ConfService, ConnectedGuard, DateListComponent, DayjsModule, Environment, FormArrayOf, FormComponent, FormControlBase, FormDate, HtmlListComponent, HttpAbstractAggregaService, HttpAbstractService, HttpServiceBase, HttpViewServiceBase, InfraServiceModule, ListComponent, LogUpdateService, ModaleComponent, NumberListComponent, ObjectId, ObjectListComponent, PageTitleService, PasswordComponent, PasswordListComponent, PromptUpdateService, RouteComponentState, RunTimeDataService, SafePipe, SharedModule, StatesService, StringListComponent, TexteListComponent, UIComponentState, UiForm, UiList, UiListMultiSelect, UiListSelect, UiListSubDoc, UiRefComponent, UiUploaderComponent, statePop$1 as statePop, UiUploaderService as ɵa, AddPipe as ɵb, DateFormatPipe as ɵc, DifferencePipe as ɵd, FromUnixPipe as ɵe, ParsePipe as ɵf, SubtractPipe as ɵg, statePop as ɵh, AuthInterceptor as ɵi };

